/**
 * @name clinica-mvp
 * @author Fellipe Orsini
 * @package clinica-mvp\app\assets\js\crud_agenda_admin.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import Swal from 'sweetalert2';
var getBaseDir = null, apiCall = null, userHasRole = null, escapeSingleQuotes = null, getPatientRoleByPatientType = null, getAgendaCategoryRoleByName = null, userHasBranch = null;
var moment = require('moment-timezone');
const AgendaReschedule = require('./update_agenda_schedule.js');

let isLoggedIn = false;
let currentPage = "loginPage";
let currentSchedules = [];
let currentBranchPatients = [];
let currentSelectedBranchId = null;
let currentSelectedBranchName = null;
let currentDetection = null;
let currentPresentSetPatientId = null;
let faceMatcher = null;
let mainRecognitionTimer = false;
let recognitionTicks = 0;
let recognitionMaxTicks = 120;
let isRecognizin = false;
let initialized = false;
let lastMatchedPatient = null;
let selfMain = this;
let activeRequests = [];
let oldSchedules = false;
var externalLoginData = null;
let currentPatientIdForFacialRecognition = null;
let lastMatchTimestamp = 0;
const MATCH_HOLD_DURATION = 20000; // 20 segundos em milissegundos

$(function () {
    import('./utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        userHasRole = utils.userHasRole;
        escapeSingleQuotes = utils.escapeSingleQuotes;
        getPatientRoleByPatientType = utils.getPatientRoleByPatientType;
        getAgendaCategoryRoleByName = utils.getAgendaCategoryRoleByName;
        userHasBranch = utils.userHasBranch;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== getBaseDir() + 'agenda/visao-geral' && location.pathname !== getBaseDir() + 'agenda/gerente')
            return;

        new Dashboard(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class Dashboard {
    constructor(onloadList = false, deps = {}) {
        this.deps = deps;
        this.responses = {};
        this.filter = {
            'AGENDA_BUSINESS_BRANCH': -1,
            'AGENDA_DOCTOR': -1,
            'AGENDA_CATEGORY': '',
            'AGENDA_START_DATE': moment().tz("America/Sao_Paulo").format().split('T')[0],
            'AGENDA_END_DATE': moment().tz("America/Sao_Paulo").format().split('T')[0],
            'AGENDA_PATIENT': '',
        }

        this.calendar = null;
        this.newEventArgs = null;
        this.updateEventArgs = null;
        this.updateModalDataObj = null;
        this.customerInsertWhatsappInput = null;
        this.customerEditWhatsappInput = null;
        this.isEditing = false;
        this.isInserting = false;
        this.EVENTS_LIST = [];
        this.FILTERED_EVENTS = [];
        this.patientType = '';
        this.operatorAllowedServices = [];
        this.savedHeight = 0;

        if (onloadList) {
            this.getCurrentMonthAgenda();
        }

        let self = this;

        $('.js-agenda-start-date').val(this.filter.AGENDA_START_DATE);
        $('.js-agenda-end-date').val(this.filter.AGENDA_END_DATE);

        $(document).on('change', '.js-agenda-branches-selector', function () {
            let branchId = $(this).val();
            self.filter.AGENDA_BUSINESS_BRANCH = branchId;
            $("#calendar").block(window._loader.loading);
            if (self.calendar) {
                self.savedHeight = 0;
                self.bindAgendaData(true);
            }
        });

        $(document).on('change', '.js-agenda-doctors-selector', function () {
            let doctorId = $(this).val();
            self.filter.AGENDA_DOCTOR = doctorId;
            $("#calendar").block(window._loader.loading);
            if (self.calendar) {
                self.savedHeight = 0;
                self.bindAgendaData(true);
            }
        });

        $(document).on('change', '.js-agenda-category', function () {
            let categoryId = $(this).val();
            self.filter.AGENDA_CATEGORY = categoryId;
            $("#calendar").block(window._loader.loading);
            if (self.calendar) {
                self.savedHeight = 0;
                self.bindAgendaData(true);
            }
        });

        let inputInterval;
        $(document).on('input', '.js-agenda-start-date', function () {
            clearTimeout(inputInterval); // Clear the previous interval
            inputInterval = setTimeout(() => {
                let startDate = $(this).val().trim();
                let date = moment(startDate);
                self.filter.AGENDA_START_DATE = moment(startDate).format().split('T')[0];
                self.filter.AGENDA_END_DATE = date.format().split('T')[0];
                $('.js-agenda-end-date').val(date.format().split('T')[0]);
                // Refresh if the year is greater than 2010
                if (date.year() > 2010) {
                    // Your refresh logic here
                    if (self.calendar) {
                        $("#calendar").block(window._loader.loading);
                        self.savedHeight = 0;
                        self.bindAgendaData(true);
                        //self.calendar.gotoDate(self.filter.AGENDA_START_DATE);
                    }
                }
            }, 500); // Interval set to 300 milliseconds
        });

        $(document).on('input', '.js-agenda-end-date', function () {
            clearTimeout(inputInterval); // Clear the previous interval
            inputInterval = setTimeout(() => {
                let startDate = $(this).val().trim();
                let date = moment(startDate);
                self.filter.AGENDA_END_DATE = moment(startDate).format().split('T')[0];
                // Refresh if the year is greater than 2010
                if (date.year() > 2010) {
                    // Your refresh logic here
                    if (self.calendar) {
                        $("#calendar").block(window._loader.loading);
                        self.savedHeight = 0;
                        self.bindAgendaData(true);
                        //self.calendar.gotoDate(self.filter.AGENDA_START_DATE);
                    }
                }
            }, 500); // Interval set to 300 milliseconds
        });

        $(document).on('click', '.js-agenda-reload-btn', function () {
            $("#calendar").block(window._loader.loading);
            if (self.calendar) {
                self.savedHeight = 0;
                self.bindAgendaData(true);
            }
        });

        $(document).on('click', '.js-agenda-nextday-btn', function () {
            let date = moment(self.filter.AGENDA_START_DATE);
            date.add('1', 'days');
            self.filter.AGENDA_START_DATE = date.format().split('T')[0];
            self.filter.AGENDA_END_DATE = date.format().split('T')[0];

            $('.js-agenda-start-date').val(date.format().split('T')[0]);
            $('.js-agenda-end-date').val(date.format().split('T')[0]);

            // Refresh if the year is greater than 2010
            if (date.year() > 2010) {
                // Your refresh logic here
                if (self.calendar) {
                    $("#calendar").block(window._loader.loading);
                    self.savedHeight = 0;
                    self.bindAgendaData(true);
                    //self.calendar.gotoDate(self.filter.AGENDA_START_DATE);
                }
            }
        });

        $(document).on('click', '.js-agenda-backday-btn', function () {
            let date = moment(self.filter.AGENDA_START_DATE);
            date.subtract('1', 'days');
            self.filter.AGENDA_START_DATE = date.format().split('T')[0];
            self.filter.AGENDA_END_DATE = date.format().split('T')[0];

            $('.js-agenda-start-date').val(date.format().split('T')[0]);
            $('.js-agenda-end-date').val(date.format().split('T')[0]);

            // Refresh if the year is greater than 2010
            if (date.year() > 2010) {
                // Your refresh logic here
                if (self.calendar) {
                    $("#calendar").block(window._loader.loading);
                    self.savedHeight = 0;
                    self.bindAgendaData(true);
                    //self.calendar.gotoDate(self.filter.AGENDA_START_DATE);
                }
            }
        });

        $(document).on('change', '.js-agenda-search-patient', function () {
            let patient = $('.js-agenda-search-patient').val().trim();
            self.filter.AGENDA_PATIENT = patient;
            $("#calendar").block(window._loader.loading);
            if (self.calendar) {
                self.savedHeight = 0;
                self.bindAgendaData(true);
            }
        });


        $(document).on('click', '.js-agenda-report-btn', function () {
            //console.log('agenda data', self.EVENTS_LIST);

            let date = moment(self.filter.AGENDA_START_DATE);
            moment.locale('pt-br');
            let dayOfWeek = date.format('dddd');
            let dayOfWeekShort = date.format('ddd');
            let dayOfMonth = date.format('DD');
            let month = date.format('MM');
            let year = date.format('YYYY');
            let branchName = $('.js-agenda-branches-selector option:selected').text();

            switch (dayOfWeek) {
                case 'Monday':
                    dayOfWeek = 'Segunda-feira';
                    break;
                case 'Tuesday':
                    dayOfWeek = 'Terça-feira';
                    break;
                case 'Wednesday':
                    dayOfWeek = 'Quarta-feira';
                    break;
                case 'Thursday':
                    dayOfWeek = 'Quinta-feira';
                    break;
                case 'Friday':
                    dayOfWeek = 'Sexta-feira';
                    break;
                case 'Saturday':
                    dayOfWeek = 'Sábado';
                    break;
                case 'Sunday':
                    dayOfWeek = 'Domingo';
            }

            //console.log('self.EVENTS_LIST', self.EVENTS_LIST);

            let prNextToEnd = 0;
            let pnTotal = 0;
            let prList = '';
            let pnList = '';
            let availablePnHours = '';
            let pnInMorning = 0;
            let pnInAfternoon = 0;
            let pnInNight = 0;
            let prListCount = 0;
            for (let i in self.EVENTS_LIST) {
                let event = self.EVENTS_LIST[i];
                //console.log('event', event);
                if (event.obj.SERVICOS != 'Avaliação + primeira sessão' && (event.obj.CATEGORIA == 'Agendado' || event.obj.CATEGORIA == 'Confirmado')) {
                    //console.log('event.obj.TIPO_PACIENTE', event.obj.TIPO_PACIENTE);
                    let sessoesContrato = [0, 1];
                    try {
                        sessoesContrato = event.obj.SESSOES_REALIZADAS.split("/");
                    } catch (ex) {
                        console.log('sessoesContrato', ex);
                        console.log('event.obj', event.obj);
                    }
                    let sessoesRealizadas = sessoesContrato[0];
                    let sessoesTotais = sessoesContrato[1];
                    let sessoesRestantes = Number(sessoesTotais) - Number(sessoesRealizadas);
                    if (sessoesRestantes <= 5 && sessoesTotais > 1) {
                        let nomePaciente = event.obj.CLIENTE_DADOS.split("|")[0];
                        prList += `${event.obj.HORA_INICIO_FORMATED} - ${nomePaciente} - ${event.obj.SESSOES_REALIZADAS}\n`;
                        prListCount++;
                    }
                    prNextToEnd++;
                }

                if (event.obj.CLIENTE_CADASTRO_FINALIZADO == 'N' && (event.obj.CATEGORIA == 'Agendado' || event.obj.CATEGORIA == 'Confirmado')) {
                    pnList += `${event.obj.HORA_INICIO_FORMATED} - ${event.title}\n`;
                    pnTotal++;
                }

                if (event.obj.CATEGORIA == 'Vago PN') {
                    availablePnHours += `${event.obj.HORA_INICIO_FORMATED} / `;
                }

                if (event.obj.CLIENTE_CADASTRO_FINALIZADO == 'N' && (event.obj.CATEGORIA == 'Agendado' || event.obj.CATEGORIA == 'Confirmado')) {
                    if (event.obj.HORA_INICIO_FORMATED.split(":")[0] < 12) {
                        pnInMorning++;
                    } else if (event.obj.HORA_INICIO_FORMATED.split(":")[0] < 18) {
                        pnInAfternoon++;
                    } else {
                        pnInNight++;
                    }
                }
            }

            let morningMessage = '';
            let afternoonMessage = '';
            let nightMessage = '';


            if (pnInMorning == 0) {
                morningMessage = 'SEM AGENDAMENTO, A AGENDA DA MANHÃ PRECISA DITAR UM BOM RITMO DE FATURAMENTO';
            } else if (pnInMorning == 1) {
                morningMessage = 'APENAS 1 PACIENTE AGENDADO, A AGENDA DA MANHÃ PRECISA DITAR UM BOM RITMO DE FATURAMENTO';
            } else if (pnInMorning > 1) {
                morningMessage = `Temos *${pnInMorning} PACIENTES* AGENDADOS PARA HOJE. A AGENDA DA MANHÃ PRECISA DITAR UM BOM RITMO DE FATURAMENTO`;
            }

            if (pnInAfternoon == 0) {
                afternoonMessage = 'SEM AGENDAMENTO, A AGENDA DA TARDE PRECISA DITAR UM BOM RITMO DE FATURAMENTO';
            } else if (pnInAfternoon == 1) {
                afternoonMessage = 'APENAS 1 PACIENTE AGENDADO, A AGENDA DA TARDE PRECISA DITAR UM BOM RITMO DE FATURAMENTO';
            } else if (pnInAfternoon > 1) {
                afternoonMessage = `Temos *${pnInAfternoon} PACIENTES* AGENDADOS PARA HOJE. A AGENDA DA TARDE PRECISA DITAR UM BOM RITMO DE FATURAMENTO`;
            }

            if (pnInNight == 0) {
                nightMessage = 'SEM AGENDAMENTO, A AGENDA DA NOITE PRECISA DITAR UM BOM RITMO DE FATURAMENTO';
            } else if (pnInNight == 1) {
                nightMessage = 'APENAS 1 PACIENTE AGENDADO, A AGENDA DA NOITE PRECISA DITAR UM BOM RITMO DE FATURAMENTO';
            } else if (pnInNight > 1) {
                nightMessage = `Temos *${pnInNight} PACIENTES* AGENDADOS PARA HOJE. A AGENDA DA NOITE PRECISA DITAR UM BOM RITMO DE FATURAMENTO`;
            }

            let whatsappMessage = `*${dayOfMonth}/${month}/${year} - ${dayOfWeek.toUpperCase()} - ${branchName}*

*POSSIBILIDADES DE VENDAS*

*PR - UP GRADE:* ${prNextToEnd} PRs

*PR - MANUTENÇÃO:* ${prListCount}\n
${prList != '' ? `
${prList}
` : ''}
*PN:*
Apenas *${pnTotal} PACIENTES* AGENDADOS PARA HOJE.
${pnList != '' ? `\n${pnList}` : ''}

*LIVRE PARA ENCAIXE DE PN:*
${availablePnHours}
            `;

            //console.log('whatsappMessage', whatsappMessage);

            self.copyToClipboard(whatsappMessage);
            window.toast({
                error: false,
                text: 'Mensagem copiada para área de transferência'
            })
        });

        $(document).on('click', '.js-agenda-report-annual-upgrade-btn', function () {
            let date = moment(self.filter.AGENDA_START_DATE);
            moment.locale('pt-br');
            let dayOfWeek = date.format('dddd');
            let dayOfWeekShort = date.format('ddd');
            let dayOfMonth = date.format('DD');
            let month = date.format('MM');
            let year = date.format('YYYY');
            let branchName = $('.js-agenda-branches-selector option:selected').text();

            switch (dayOfWeek) {
                case 'Monday':
                    dayOfWeek = 'Segunda-feira';
                    break;
                case 'Tuesday':
                    dayOfWeek = 'Terça-feira';
                    break;
                case 'Wednesday':
                    dayOfWeek = 'Quarta-feira';
                    break;
                case 'Thursday':
                    dayOfWeek = 'Quinta-feira';
                    break;
                case 'Friday':
                    dayOfWeek = 'Sexta-feira';
                    break;
                case 'Saturday':
                    dayOfWeek = 'Sábado';
                    break;
                case 'Sunday':
                    dayOfWeek = 'Domingo';
            }

            //console.log('self.EVENTS_LIST', self.EVENTS_LIST);

            let prNextToUpgrade = 0;
            let tableHtml = '<table class="table table-bordered">';
            tableHtml += '<thead>';
            tableHtml += '<tr>';
            tableHtml += '<th>Nome</th>';
            tableHtml += '<th>Contrato</th>';
            tableHtml += '<th>Sessões</th>';
            tableHtml += '<th>Valor do Contrato</th>';
            tableHtml += '<th>Valor do Plano Anual</th>';
            tableHtml += '<th>Sessões Restantes</th>';
            tableHtml += '<th>Valor da Sessão</th>';
            tableHtml += '</tr>';
            tableHtml += '</thead>';
            tableHtml += '<tbody>';

            for (let i in self.EVENTS_LIST) {
                let event = self.EVENTS_LIST[i];
                //console.log('event', event);
                if (event.obj.SERVICOS != 'Avaliação + primeira sessão' && (event.obj.CATEGORIA == 'Agendado' || event.obj.CATEGORIA == 'Confirmado')) {
                    console.log('event', event);
                    if (event.obj.SESSOES_REALIZADAS && event.obj.CONTRATOS_ATIVOS_SEM_USO == 0) {
                        let totalSessoes = event.obj.SESSOES_REALIZADAS.split('/')[1];
                        if (totalSessoes < 52) {
                            let dadosPaciente = event.obj.CLIENTE_DADOS.split('|');
                            let valorPlanoAnual = 6760;

                            tableHtml += `<tr>`;
                            tableHtml += `<td>${dadosPaciente[0]}</td>`;
                            tableHtml += `<td>${event.obj.CONTRATO_ID}</td>`;
                            tableHtml += `<td>${totalSessoes}</td>`;
                            tableHtml += `<td>R$${event.obj.CONTRATO_VALOR_TOTAL}</td>`;
                            tableHtml += `<td>R$${valorPlanoAnual - event.obj.CONTRATO_VALOR_TOTAL}</td>`;
                            tableHtml += `<td>${52 - totalSessoes}</td>`;
                            tableHtml += `<td>R$${((valorPlanoAnual - event.obj.CONTRATO_VALOR_TOTAL) / (52 - totalSessoes)).toFixed(2)}</td>`;
                            tableHtml += `</tr>`;

                            prNextToUpgrade++;
                        }
                    }
                }
            }

            tableHtml += '</tbody>';
            tableHtml += '</table>';

            let printWindow = window.open("", "_blank");
            printWindow.document.write(`
                <html>
                <head>
                    <title>Relatório Upgrade Anual 52 sessões</title>
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.10.5/font/bootstrap-icons.min.css">
                    <style>
                    body { font-family: Arial, sans-serif; padding: 20px; }
                    .modal-body { padding: 20px; }
                    </style>
                </head>
                <body>
                    ${tableHtml}
                    <script>
                    window.onload = function() {
                        window.print();
                        window.close();
                    };
                    <\/script>
                </body>
                </html>
            `);
            printWindow.document.close();

            window.toast({
                error: false,
                text: 'Aba para impressão aberta'
            })
        });

        // Resgata lista de serviços
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/employee/services',
            successCallback: function (res) {
                console.log('dashboard.js/employee/services', '#agenda_insert_start_hour', res);

                if (res.error) {

                } else {
                    self.operatorAllowedServices = res.data;
                    let html = '<option selected default value="">-- ' + (self.patientType == 'PR' ? 'Seleção Automática' : 'Selecione uma opção') + ' --</option>';
                    for (let i in res.data) {
                        let serviceObj = res.data[i];
                        html += `
                            <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" data-info='${JSON.stringify(serviceObj)}' data-patient-type-id="${serviceObj.TIPO_PACIENTE_ID}">${serviceObj.SERVICO}</option>
                        `;
                    }
                    $('#agenda_insert_service').html(html);

                    html = '';
                    for (let i in res.data) {
                        let serviceObj = res.data[i];
                        if (serviceObj.SERVICO.toLowerCase().indexOf('cortesia') == -1 && (userHasRole('MANAGER') || userHasRole('COMMERCIAL_ASSISTANT')) && userHasBranch(14))
                            continue;
                        html += `
                            <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" data-info='${JSON.stringify(serviceObj)}' data-patient-type-id="${serviceObj.TIPO_PACIENTE_ID}">${serviceObj.SERVICO}</option>
                        `;
                    }
                    $('#edit_current_account_service').html(html);
                }
            },
            errorCallback(err) {
                console.error('ERROR', 'dashboard.js/employee/services', '#agenda_insert_start_hour', err);
            }
        });
    }

    copyToClipboard(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand('copy');
            console.log('Text copied to clipboard');
        } catch (err) {
            console.error('Unable to copy to clipboard:', err);
        } finally {
            document.body.removeChild(textarea);
        }
    }

    getCurrentMonthAgenda() {
        let self = this;
        function OnBusinessReady() {
            $(document).ready(function () {
                /*self.customerInsertWhatsappInput = window.intlTelInput(document.querySelector('input[id="agenda_insert_customer_whatsapp"]'), {
                    initialCountry: "br",
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
                });*/
                self.customerEditWhatsappInput = window.intlTelInput(document.querySelector('input[id="agenda_edit_customer_whatsapp"]'), {
                    initialCountry: "br",
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
                });
                self.bindAgendaUpdateProcess();
            });

            self.deps.apiCall({
                endpoint: 'api/v1/business/agenda_categories',
                method: 'GET',
                successCallback: function (res) {
                    console.log('crud_agenda_admin.js/business/agenda_categories', res);

                    if (res.error) {

                    } else {
                        let html = '<option selected default value="">-- Selecione --</option>';
                        for (let i in res.data) {
                            let category = res.data[i];
                            html += `<option value="${category.CATEGORIA}">${category.CATEGORIA}</option>`;
                        }
                        $('.js-agenda-category').html(html);
                    }
                },
                errorCallback: function (err) {

                }
            })

            //get select options count
            setTimeout(function () {
                if ($('.js-agenda-branches-selector option').length === 2) {
                    // select first option
                    $('.js-agenda-branches-selector').prop('selectedIndex', 1);
                    $('.js-agenda-branches-selector').trigger('change');
                }
            }, 500);

            $('#calendar').html('<br /><center><h3>Por favor filtre por filial para visualizar a agenda.</h3></center>');
        };
        window.businessReadyFunctions.push(OnBusinessReady);

        function OnDoctorsReady() {
            if (self.isEditing) {
                $('#agenda_edit_doctor').val(self.updateModalDataObj.obj.DOUTORES_ID);
                $('#agenda_edit_doctor').trigger('change');

                $('#agenda_edit_date').val(self.updateModalDataObj.obj.DATA_INICIO_FORMATED);
                $('#agenda_edit_date').trigger('change');
            }

            if (!self.calendar) {
                $('#calendar').html(`
                    <div class="js-agenda-calendar-container">
                        <div class="d-flex justify-content-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                `);

                var intv = setInterval(function () {
                    if (!window._sessionData.businessBranches)
                        return;

                    clearInterval(intv);

                    let startStr = moment().tz("America/Sao_Paulo").format().split('T')[0];
                    let endStr = moment().tz("America/Sao_Paulo").format().split('T')[0];

                    if (startStr != self.filter.AGENDA_START_DATE || endStr != self.filter.AGENDA_END_DATE) {
                        self.filter.AGENDA_START_DATE = startStr;
                        self.filter.AGENDA_END_DATE = endStr;

                        //console.log('startStr', startStr);
                        //console.log('endStr', endStr);

                        $('.js-agenda-start-date').val(startStr);
                        $('.js-agenda-end-date').val(endStr);
                    }

                    self.calendar = true;
                    self.bindAgendaData();
                }, 1000);
            }
        }
        window.doctorsReadyFunctions.push(OnDoctorsReady);
    }

    async bindAgendaData(create_table = true) {
        let self = this;
        if (this.agendaRequest) {
            if (typeof this.agendaRequest !== 'undefined' || null) {
                this.agendaRequestTerminated = true;
                this.agendaRequest.abort();
            }
        }

        if (self.filter.AGENDA_BUSINESS_BRANCH == 14) {
            const isToday = moment(self.filter.AGENDA_START_DATE).isSame(moment(), 'day');

            if (!isToday) {
                currentBranchPatients = [];
                currentSchedules = [];
            } else {
                try {
                    const rawResponse = await fetch(window._baseDir + 'api/v1/facial-recognition/get-branch-patients?branchId=' + self.filter.AGENDA_BUSINESS_BRANCH + '&date=' + self.filter.AGENDA_START_DATE, {
                        method: 'GET'
                    });
                    const content = await rawResponse.json();
                    currentBranchPatients = !content.error ? content.data : [];
                } catch (ex) {
                    console.error('[main.js]', 'get-branch-patients', 'TheQuiro server failed to fullfil a response.', ex?.message)
                    return [];
                }

                try {
                    const rawResponse = await fetch(window._baseDir + 'api/v1/facial-recognition/get-schedules?branchId=' + self.filter.AGENDA_BUSINESS_BRANCH + '&date=' + self.filter.AGENDA_START_DATE, {
                        method: 'GET'
                    });
                    const content = await rawResponse.json();
                    currentSchedules = !content.error ? content.data : []
                } catch (ex) {
                    console.error('[main.js]', 'get-schedules', 'TheQuiro server failed to fullfil a response.', ex?.message)
                    return [];
                }
            }
        }

        this.agendaRequest = apiCall({
            endpoint: 'api/v1/employee/agenda',
            method: 'POST',
            data: {
                start: self.filter.AGENDA_START_DATE,
                end: self.filter.AGENDA_END_DATE,
                branchId: self.filter.AGENDA_BUSINESS_BRANCH,
                doctorId: self.filter.AGENDA_DOCTOR,
                categoryId: self.filter.AGENDA_CATEGORY,
                ...self.filter.AGENDA_PATIENT !== '' ? { patient: self.filter.AGENDA_PATIENT } : {}
            },
            successCallback: function (res) {
                console.log('[Calendar:events] dashboard.js/employee/agenda', res);
                $("#calendar").unblock()
                $('.fc-view-harness').css('opacity', '1');

                if (!res.error) {
                    const element = document.getElementsByClassName('js-business-doctors-selector');
                    let array = {};
                    for (let i in element[0].options) {
                        array[element[0].options[i].value] = element[0].options[i].text;
                    }
                    //console.log('array', array);

                    for (let i in res.data) {
                        let eventData = res.data[i];
                        //console.log('eventData', eventData);
                        if (!array[eventData.obj.DOUTORES_ID]) {
                            res.data[i] = null;
                        } else {
                            res.data[i].DOUTOR = array[eventData.obj.DOUTORES_ID];
                        }
                    }
                    res.data = res.data.filter(o => o != null);
                    self.EVENTS_LIST = res.data;
                    //console.log('Loaded events', res.data.length);
                    self.updateAgendaData(res.data, create_table);
                }
            },
            errorCallback: function (res) {
                if (!self.agendaRequestTerminated) {
                    $("#calendar").block(window._loader.error);
                } else {
                    self.agendaRequestTerminated = false;
                }
                //failureCallback();
            }
        });
    }

    updateAgendaData(data, create_table = true) {
        //console.log('updateAgendaData', data.length, create_table);
        let self = this;
        let html = ``;
        let patientsTypes = {};

        let endOfContactPatientsHtml = false;
        for (let i = 0; i < data.length; i++) {
            let eventData = data[i];
            patientsTypes[eventData.obj.TIPO_PACIENTE] = patientsTypes[eventData.obj.TIPO_PACIENTE] ? patientsTypes[eventData.obj.TIPO_PACIENTE] + 1 : 1;
            //console.log('eventData', eventData);
            if (eventData.obj.CATEGORIA == 'Agendado' || eventData.obj.CATEGORIA == 'Confirmado') {
                if (eventData.obj.SESSOES_REALIZADAS) {
                    if (eventData.obj.SESSOES_REALIZADAS != '01/01') {
                        let sessoes = eventData.obj.SESSOES_REALIZADAS.split('/');
                        //console.log('sessoes', sessoes);
                        if ((sessoes[1] - sessoes[0]) <= 5) {
                            if (!endOfContactPatientsHtml) {
                                endOfContactPatientsHtml = '<ul>';
                            }
                            endOfContactPatientsHtml += `<li>${eventData.obj.HORA_INICIO_FORMATED} ~ ${eventData.obj.HORA_FINAL_FORMATED} - ${eventData.title}</li>`;
                        }
                    }
                }
            }
        }

        if (endOfContactPatientsHtml) {
            endOfContactPatientsHtml += '</ul>';
        }

        if (create_table) {
            html = `
                <!-- Mostra data atual -->
                <div class="alert alert-primary" role="alert">
                    <h4 class="alert-heading mb-0">Agenda do dia ${moment(self.filter.AGENDA_START_DATE).tz("America/Sao_Paulo").format('DD/MM/YYYY')}</h4>
                    <button class="btn btn-primary js-agenda-reload-btn" style="margin-top:10px;"><i class="fas fa-sync-alt"></i> Recarregar</button>
                    <button class="btn btn-secondary js-agenda-backday-btn" style="margin-top:10px;"><i class="fas fa-backward"></i> Dia anterior</button>
                    <!-- botão ir para próximo dia -->
                    <button class="btn btn-secondary js-agenda-nextday-btn" style="margin-top:10px;"><i class="fas fa-forward"></i> Próximo dia</button>
                    ${userHasRole('ADMIN') ? `<button class="btn btn-secondary js-agenda-report-btn" style="margin-top:10px;"><i class="fas fa-file-alt"></i> Relatório do Dia</button>` : ''}
                    ${`<button class="btn btn-secondary js-agenda-report-annual-upgrade-btn" style="margin-top:10px;"><i class="fas fa-file-alt"></i> Relatório Upgrade Anual 52 sessões</button>`}
                </div>
                <!-- count PRs and PNS-->
                <div class="alert alert-primary" role="alert">
                    <h4 class="alert-heading mb-0">Contagem de pacientes por tipo</h4>
                    <div class="js-agenda-patients-types-list mt-3 d-flex flex-wrap gap-2">
                        ${Object.keys(patientsTypes).map((key) => {
                return `<span class="badge bg-primary fs-6">${key}: ${patientsTypes[key]}</span>`;
            }).join('')}
                    </div>
                </div>
                <div class="alert alert-warning js-agenda-end-of-contact-patients-alert ${endOfContactPatientsHtml ? '' : 'd-none'}">
                    <h4 class="alert-heading mb-0">Atenção aos pacientes agendados hoje que estão próximos de finalizar o tratamento</h4>
                    <div class="js-agenda-end-of-contact-patients-list">
                        ${endOfContactPatientsHtml ? `<p>${endOfContactPatientsHtml}</p>` : `<p>Não há mais pacientes para contato.</p>`}
                    </div>
                </div>
                <div class="js-calendar-agenda-container" style="min-height:660px;">
                    <table class="table tableFixHead table-striped table-hover table-responsive responsive-table w-100"  style="width:100%; min-height:700px; overflow-y:scroll;">
                        <thead>
                            <tr>
                                <th></th>
                                <th style="min-width:90px;">Data</th>
                                <th style="min-width:90px;">Horário</th>
                                <th class="text-center" style="min-width:100px;">Doutor(a)</th>
                                <th style="min-width:200px;">Categoria</th>
                                <th style="min-width:20px;">Zap</th>
                                <th>Paciente</th>
                                ${self.filter.AGENDA_BUSINESS_BRANCH == 14 ? `<th style="min-width:20px;">Facial</th>` : ``}
                            </tr>
                        </thead>
                        <tbody class="js-calendar-body">
                            <tr>
                                <td colspan="5" class="text-center">
                                   Por favor, aguarde, carregando...
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            `;
            $(".js-agenda-calendar-container").html(html);
        } else {
            $('.js-agenda-patients-types-list').html(`
                ${Object.keys(patientsTypes).map((key) => {
                return `<span class="badge bg-primary fs-6">${key}: ${patientsTypes[key]}</span>`;
            }).join('')}
            `);
            $('.js-agenda-end-of-contact-patients-list').html(endOfContactPatientsHtml);
            if (endOfContactPatientsHtml) {
                $('.js-agenda-end-of-contact-patients-alert').removeClass('d-none');
            } else {
                $('.js-agenda-end-of-contact-patients-alert').addClass('d-none');
            }
        }

        if (data.length === 0) {
            $('.js-calendar-body').html(`
                <tr>
                    <td colspan="5" class="text-center">
                        Registros não encontrados nesta data
                    </td>
                </tr>
            `);
        } else {
            $('.js-calendar-body').html('');
        }

        for (let i = 0; i < data.length; ++i) {
            let eventData = data[i];
            //console.log('eventData', eventData);

            var eventDataInfo = escapeSingleQuotes(JSON.stringify(eventData).replace(/"/g, '&quot;'));

            // add slahes to customer name
            if (eventData.obj) {
                eventDataInfo = escapeSingleQuotes(JSON.stringify(eventData).replace(/"/g, '&quot;'));
                /*if (eventData.obj.CLIENTE_NOME && eventData.obj.CLIENTE_NOME != '') {
                    eventData.obj.CLIENTE_NOME = eventData.obj.CLIENTE_NOME.replace(/'/g, "");
                }
                if (eventData.obj.CLIENTE_DADOS && eventData.obj.CLIENTE_DADOS != '') {
                    eventData.obj.CLIENTE_DADOS = eventData.obj.CLIENTE_DADOS.replace(/'/g, "");
                }*/
            }
            if (eventData.title && eventData.title != '') {
                eventData.title = eventData.title.replace(/'/g, "");
            }

            if (create_table) {
                $('.js-calendar-body').append(`
                    <tr class="js-agenda-schedule cursor-pointer" data-schedule-id="${eventData.obj.ID}" data-schedule-data="${eventDataInfo}" style="${eventData.obj.SESSAO_PAGA == 'N' ? 'background:#ffa07a;' : ''}">
                        <td data-label="ID"><small>${eventData.obj.ID}</small></td>
                        <td data-label="Data"><small>${moment(eventData.obj.DATA_INICIO_FORMATED).format('DD/MM/YYYY')}</small></td>
                        <td data-label="Horário"><small>${eventData.obj.HORA_INICIO_FORMATED} ~ ${eventData.obj.HORA_FINAL_FORMATED}</small></td>
                        <td data-label="Doutor(a)"><small>${eventData.DOUTOR}</small></td>
                        <td data-label="Categoria">
                            <button class="btn" style="background-color:${eventData.color}; color:#FFF; width:100%;">${eventData.extendedProps.category}</button>
                        </td>
                        <td data-label="Zap" class="js-agenda-wpp-message" data-schedule-data="${eventDataInfo}">
                            <div class="d-flex justify-content-center">
                                <i class="fab fa-whatsapp" style="font-size:20px;"></i>
                            </div>
                        </td>
                        <td data-label="Paciente">
                            ${eventData.title ? `<button class="btn" style="background-color:${eventData.color}; color:#FFF; width:100%;">${eventData.title}</span>` : '<button class="btn" style="background-color:#FFF; color:#000; width:100%;">Clique aqui para agendar um(a) paciente.</span>'}
                        </td>
                        ${self.filter.AGENDA_BUSINESS_BRANCH == 14 ? `
                            <td data-label="Facial">
                                ${!eventData.obj.FACE_DESCRIPTORS && (eventData.obj.C_CORRENTE_ID != 0 && eventData.obj.C_CORRENTE_ID != null) ?
                            `<button type="button" class="btn btn-outline-primary js-open-capture-patient btn-sm" data-patient-id="${eventData.obj.CLIENTES_ID}">📷 Cadastrar facial</button>` : (
                                (eventData.obj.CATEGORIA == 'Agendado' || eventData.obj.CATEGORIA == 'Confirmado')
                                    && eventData.obj.FACE_DESCRIPTORS
                                    && (eventData.obj.C_CORRENTE_ID != 0 || eventData.obj.C_CORRENTE_ID != null) ?
                                    `<button type="button" class="btn btn-primary js-start-facial-recognition btn-sm" data-patient-id="${eventData.obj.CLIENTES_ID}">🧑 Marcar presença</button>` :
                                    ((eventData.obj.CATEGORIA == 'Agendado' || eventData.obj.CATEGORIA == 'Confirmado')
                                        && (eventData.obj.FACE_DESCRIPTORS || !eventData.obj.FACE_DESCRIPTORS)
                                        && (eventData.obj.C_CORRENTE_ID == 0 || eventData.obj.C_CORRENTE_ID == null) ?
                                        `⚠️ Lance o Conta Corrente!` : '')
                            )}
                            </td>
                        ` : ''}
                    </tr>
                `);
            } else {
                $('.js-agenda-schedule[data-schedule-id="' + eventData.obj.ID + '"]').data('schedule-data', eventDataInfo);
                $('.js-agenda-schedule[data-schedule-id="' + eventData.obj.ID + '"]').html(`
                    <td><small>${eventData.obj.ID}</small></td>
                    <td><small>${eventData.obj.HORA_INICIO_FORMATED} ~ ${eventData.obj.HORA_FINAL_FORMATED}</small></td>
                    <td><small>Doutor(a) ${eventData.DOUTOR}</small></td>
                    <td>
                        <button class="btn" style="background-color:${eventData.color}; color:#FFF; width:100px;">${eventData.extendedProps.category}</button>
                    </td>
                    <td>
                        ${eventData.title ? `<button class="btn" style="background-color:${eventData.color}; color:#FFF; width:100%;">${eventData.title}</span>` : '<button class="btn" style="background-color:#FFF; color:#000; width:100%;">Clique aqui para agendar um(a) paciente.</span>'}
                    </td>
                `);
            }
        }

        console.log('patientsTypes', patientsTypes);

        if (self.savedHeight > 0) {
            setTimeout(function () {
                $('.js-calendar-agenda-container').scrollTop(self.savedHeight);
            }, 250);
        }
    }

    bindAgendaUpdateProcess() {
        let self = this;

        // Detect scrolled height
        $(document).on('.js-calendar-agenda-container', 'scroll', function () {
            var scroll = $(this).scrollTop();
            //console.log('scroll', scroll);
            if (scroll > 0) {
                self.savedHeight = scroll;
            }
        });

        // Detecta clique para visualizar/agendar um paciente
        $(document).on('click', '.js-agenda-schedule', function () {
            let scheduleData = $(this).data('schedule-data');
            console.log('scheduleData', scheduleData);

            $('#modal-update-event-manager').modal('show');
            $('.js-update-event-manager-dialog-title-id').html(scheduleData.obj.ID);
            $('#agenda_edit_business_branch').val(scheduleData.obj.FILIAL_ID);
            //$('#agenda_edit_business_branch').trigger('change');
            setTimeout(function () {
                $(".modal-update-event-manager-dialog").block(window._loader.loading);
            }, 250);
            self.isEditing = true;
            self.agendaEditExistingCustomer = false;
            let categoria = scheduleData.obj.CATEGORIA ? scheduleData.obj.CATEGORIA.split(' ') : null;
            self.patientType = scheduleData.obj.TIPO_PACIENTE ? scheduleData.obj.TIPO_PACIENTE : (categoria ? categoria[1] : '');
            let role = getPatientRoleByPatientType(self.patientType);
            //console.log('self.patientType role', self.patientType, role);

            self.updateModalDataObj = scheduleData;

            let findDoctorName = window.businessBranchDoctors.find((obj) => {
                return parseInt(obj.STAFF_ID) == parseInt(scheduleData.obj.DOUTORES_ID);
            });
            //console.log('findDoctorName', findDoctorName);
            //let doctorHtml = '<option selected default value="'+scheduleData.obj.DOUTORES_ID+'">'+findDoctorName.PRIMEIRO_NOME+'</option>';
            // $('select[name="agenda_edit_doctor"]').html(doctorHtml);

            $('#agenda_edit_doctor').val(scheduleData.obj.DOUTORES_ID);
            $('#agenda_edit_doctor').trigger('change');

            $('#agenda_edit_date').val(scheduleData.obj.DATA_INICIO_FORMATED);
            $('#agenda_edit_date').trigger('change');

            self.currentAccountId = false;

            $('.js-agenda-edit-post-service').addClass('d-none');
            $('.js-agenda-edit-search-existing-patient').addClass('d-none');
            $('.js-manager-update-schedule-mark-current-account-as-paid').addClass('d-none');
            $('.js-agenda-edit-post-patient').addClass('d-none');

            if (scheduleData.obj.CLIENTE_DADOS === null) {
                $('.js-manager-update-schedule-event-options').addClass('d-none');
                $('.js-manager-update-schedule-event-plug-in-options').removeClass('d-none');
                $('.js-manager-agenda-edit-submit-button').removeClass('d-none');
                $('#agenda_edit_search_customer').attr('readonly', false);
                $('#agenda_edit_search_customer').attr('disabled', false);
                $('#agenda_edit_service').attr('readonly', false);
                $('#agenda_edit_customer_origin').attr('readonly', false);
                $('#agenda_edit_customer_name').attr('readonly', false);
                $('#agenda_edit_customer_whatsapp').attr('readonly', false);
                $('#agenda_edit_customer_profession').attr('readonly', false);
                $('#agenda_edit_customer_origin').val('');
                $('#agenda_edit_doctor').attr('readonly', true);
                $('.js-agenda-edit-schedule-doctor-button').addClass('d-none');
                $('.js-agenda-edit-pre-registered').removeClass('d-none');
                $('.js-agenda-edit-post-service').addClass('d-none');
                $('.js-manager-update-schedule-event-accordion-title').html('<i class="fas fa-eye"></i>&nbsp;&nbsp;Clique para agendar um(a) paciente</span>');
            } else {
                $('.js-manager-update-schedule-event-options').removeClass('d-none');
                $('.js-manager-update-schedule-event-plug-in-options').addClass('d-none');
                $('.js-manager-agenda-edit-submit-button').addClass('d-none');
                $('#agenda_edit_search_customer').attr('readonly', true);
                $('#agenda_edit_search_customer').attr('disabled', true);
                $('#agenda_edit_service').attr('readonly', true);
                $('#agenda_edit_customer_origin').attr('readonly', true);
                $('#agenda_edit_customer_name').attr('readonly', true);
                $('#agenda_edit_customer_whatsapp').attr('readonly', true);
                $('#agenda_edit_customer_profession').attr('readonly', true);
                $('#agenda_edit_customer_profession').val(scheduleData.obj.CLIENTE_PROFISSAO);
                $('#agenda_edit_customer_origin').val(scheduleData.obj.CLIENTE_ORIGEM);
                $('.js-agenda-edit-post-patient').removeClass('d-none');
                $('.js-agenda-edit-post-service').removeClass('d-none');
                $('.js-agenda-edit-pre-registered').addClass('d-none');
                if (scheduleData.obj.SESSAO_PAGA == 'N') {
                    $('.js-manager-update-schedule-mark-current-account-as-paid').removeClass('d-none');
                }
                $('.js-manager-update-schedule-event-accordion-title').html('<i class="fas fa-eye"></i>&nbsp;&nbsp;Clique p/ver informações do agendamento</span>');

                if (scheduleData.obj.CATEGORIA == 'Presente' || scheduleData.obj.CATEGORIA == 'Em atendimento' || scheduleData.obj.CATEGORIA == 'Agendado' || scheduleData.obj.CATEGORIA == 'Confirmado') {
                    $('#agenda_edit_doctor').attr('readonly', false);
                    $('.js-agenda-edit-schedule-doctor-button').removeClass('d-none');
                } else {
                    $('#agenda_edit_doctor').attr('readonly', true);
                    $('.js-agenda-edit-schedule-doctor-button').addClass('d-none');
                }

                let role = getPatientRoleByPatientType(self.patientType);
                if (role !== 'PACIENTE_NOVO') {
                    //$('.js-manager-agenda-reschedule-btn').removeClass('d-none');
                } else {
                    if (scheduleData.obj.HUNTER == 'Clinica') {
                        $('.js-manager-agenda-reschedule-btn').addClass('d-none');
                    }
                }
            }
        });

        $(document).on('click', '.js-agenda-wpp-message', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let scheduleData = $(this).data('schedule-data');
            self.currentWppMessageScheduleData = scheduleData;
            let splitPatientData = scheduleData.obj.CLIENTE_DADOS.split("|");
            //console.log('scheduleData.obj.CLIENTE_DADOS', scheduleData.obj.CLIENTE_DADOS);
            //console.log('splitPatientData', splitPatientData);
            let nomePaciente = splitPatientData[0]
            let sexo = splitPatientData[2] == 'M' ? 'Sr. ' : 'Sra. ';
            // Primeiro, defina o locale para português do Brasil
            moment.locale('pt-br');

            // Então, use o formato 'dddd' para obter o nome completo do dia da semana
            let mensagem = `${sexo}${nomePaciente}, está agendado uma sessão para: ${moment(scheduleData.obj.DATA_INICIO_FORMATED).format('DD/MM/YYYY')} às ${scheduleData.obj.HORA_INICIO_FORMATED} (${moment(scheduleData.obj.DATA_INICIO_FORMATED).format('dddd')}) com o(a) Dr(a). ${scheduleData.DOUTOR}. Podemos confirmar? - Atenciosamente, Ajustar - Clínicas de Quiropraxia`;

            $('#agenda_info').val(`${scheduleData.obj.ID} - ${moment(scheduleData.obj.DATA_INICIO_FORMATED).format('DD/MM/YYYY')} - ${scheduleData.obj.HORA_INICIO_FORMATED} - ${moment(scheduleData.obj.DATA_INICIO_FORMATED).format('dddd')}`);
            $('#agenda_patient').val(splitPatientData[0]);
            $('#agenda_phone').val(splitPatientData[1]);
            $('#agenda_send_whatsapp_message').val(mensagem);

            $("#modal-agenda-send-whatsapp-message").modal('show');

            let url = 'https://api.whatsapp.com/send/?type=phone_number&app_absent=0&' + $.param({
                phone: `55${splitPatientData[1]}`,
                text: mensagem
            });
            $('.js-agenda-send-whatsapp-message-submit-button').attr('href', url);
            $('.js-agenda-send-whatsapp-message-submit-button').attr('target', '_blank');
        });

        $(document).on('input', '#agenda_send_whatsapp_message', function () {
            let splitPatientData = self.currentWppMessageScheduleData.obj.CLIENTE_DADOS.split("|");
            let url = 'https://api.whatsapp.com/send/?type=phone_number&app_absent=0&' + $.param({
                phone: `55${splitPatientData[1]}`,
                text: $(this).val()
            });
            $('.js-agenda-send-whatsapp-message-submit-button').attr('href', url);
            $('.js-agenda-send-whatsapp-message-submit-button').attr('target', '_blank');
        });

        $('#agenda_edit_search_customer').select2({
            placeholder: "Busque por telefone, nome ou email",
            theme: 'bootstrap-5',
            dropdownParent: $(".js-agenda-edit-search-existing-patient"),
            minimumInputLength: 3,
            ajax: {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function (params) {
                    var query = {
                        search: params.term,
                        branchId: $('#agenda_edit_business_branch').val() || -1,
                        page: params.page || 1
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function (k, v) {
                        if (v.CONTRATOS != null) {
                            results.push({
                                id: v.ID,
                                text: `${v.TEXT}${v.CPF != null ? ` - ${v.CPF}` : ` - ${v.PASSAPORTE}`}`,
                                info: v
                            });
                        }
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });

        $('#agenda_edit_search_customer').on('select2:select', function (e) {
            self.agendaEditExistingCustomer = e.params.data.info.ID;
            self.agendaEditExistingCustomerContracts = e.params.data.info.CONTRATOS;

            $('#agenda_edit_customer_name').val(e.params.data.text);
            $('#agenda_edit_customer_whatsapp').val(e.params.data.info.FONE_CELULAR);
            $('#agenda_edit_customer_origin').val(e.params.data.info.ORIGEM_ID);

            if (e.params.data.info.FONE_CELULAR) {
                self.customerEditWhatsappInput.setNumber(e.params.data.info.FONE_CELULAR);
            } else {
                if (e.params.data.info.FONE_RESIDENCIAL) {
                    self.customerEditWhatsappInput.setNumber(e.params.data.info.FONE_RESIDENCIAL);
                }
            }

            $('#agenda_edit_customer_name').attr('readonly', true);
            $('#agenda_edit_customer_whatsapp').attr('readonly', true);
            $('#agenda_edit_customer_profession').attr('readonly', true);
            $('#agenda_edit_customer_origin').attr('readonly', true);

            $('.js-edit-agenda-customer-current-account-launch').data('patient-info', JSON.stringify(e.params.data.info));

            if (e.params.data.info.CONTRATOS != null) {
                $(".js-agenda-edit-manager-select-contract-container").html(`
                    Por favor aguarde, estamos carregando os contratos do paciente...
                `);

                $(".modal-update-event-manager-dialog").block(window._loader.loading);
                apiCall({
                    method: 'GET',
                    endpoint: 'api/v1/patient/get_current_account',
                    data: {
                        patient: e.params.data.info.ID
                    },
                    successCallback: function (res) {
                        console.log('crud_agenda_admin.js/patient/contract #agenda_edit_search_customer', 'select2:select', res);
                        $(".modal-update-event-manager-dialog").unblock();

                        if (res.error) {
                            window.toast({
                                error: true,
                                text: res.message
                            })
                        } else {
                            $('.js-agenda-edit-manager-currenct-account-transaction-container').removeClass('d-none');

                            if (res.data.length === 0) {
                                return $(".js-agenda-edit-manager-select-contract-container").html(`Este paciente não possui nenhum contrato.`);
                            }

                            let html = `
                                <div class="accordion mb-3 js-update-business-schedule-patient-contracts-container" id="accordionInsertBusinessSchedule">
                                    
                                </div>`;
                            $(".js-agenda-edit-manager-select-contract-container").html(html);

                            let htmlInsrt = '';
                            let contratoAtual = -1;
                            let foundFreeSession = false;

                            let sessionServiceLiberated = [];
                            let lastAvailableServiceId = [];
                            let hasContractWithoutCompleteSigning = [];
                            let availableSessionsPerService = {}; // Controla sessões disponíveis por serviço
                            let firstSessionPerService = {}; // Controla se já foi encontrada a primeira sessão de cada serviço

                            let liberouSessaoFutura = {}; // contratoId -> serviceId: true/false

                            for (let i = 0; i < res.data.length; ++i) {
                                let contaCorrente = res.data[i];
                                let serviceId = contaCorrente.SERVICOS_ID;

                                // Inicializa controle por contrato
                                if (!liberouSessaoFutura[contaCorrente.CONTRATO_ID]) {
                                    liberouSessaoFutura[contaCorrente.CONTRATO_ID] = {};
                                }
                                if (typeof liberouSessaoFutura[contaCorrente.CONTRATO_ID][serviceId] === 'undefined') {
                                    liberouSessaoFutura[contaCorrente.CONTRATO_ID][serviceId] = false;
                                }

                                // Sessão futura = não agendada, não realizada, não cancelada
                                let isSessaoFutura = contaCorrente.AGENDA_ID == null && contaCorrente.DATA_ATENDIMENTO == null && contaCorrente.STATUS == null;

                                let habilitarInput = false;
                                if (isSessaoFutura && !liberouSessaoFutura[contaCorrente.CONTRATO_ID][serviceId]) {
                                    habilitarInput = true;
                                    liberouSessaoFutura[contaCorrente.CONTRATO_ID][serviceId] = true; // Marca que já liberou uma sessão futura desse serviço neste contrato
                                }

                                let serviceName = '';
                                for (let x = 0; x < self.operatorAllowedServices.length; x++) {
                                    let service = self.operatorAllowedServices[x];
                                    if (service.ID == contaCorrente.SERVICOS_ID) {
                                        serviceName = service.SERVICO;
                                        break;
                                    }
                                }

                                let doctorName = contaCorrente.STAFF_NAME;
                                /*for(let x = 0; x < window.businessBranchDoctors.length; x++) {
                                    let doctor = window.businessBranchDoctors[x];
                                    if (doctor.DOUTOR_ID == contaCorrente.STAFF_ID) {
                                        doctorName = doctor.PRIMEIRO_NOME;
                                        break;
                                    }
                                }*/

                                let contratoData = null;
                                for (let x = 0; x < Object.keys(self.agendaEditExistingCustomerContracts).length; x++) {
                                    let contratoId = Object.keys(self.agendaEditExistingCustomerContracts)[x];
                                    if (contaCorrente.CONTRATO_ID == contratoId) {
                                        contratoData = self.agendaEditExistingCustomerContracts[contratoId];
                                        break;
                                    }
                                }
                                //console.log('self.agendaEditExistingCustomerContracts', self.agendaEditExistingCustomerContracts);
                                //console.log('contratoData', contratoData);
                                if (contratoData == null) {
                                    contratoData = {
                                        ID: contaCorrente.CONTRATO_ID,
                                        DATA_ADESAO: null,
                                        DATA_ENCERRAMENTO: null,
                                        STATUS: 'B',
                                        UPLOAD_CONTRATO: 'N',
                                        sessoes: []
                                    }
                                }

                                // Verifica se já existe uma sessão disponível para este serviço
                                //let serviceId = contaCorrente.SERVICOS_ID;
                                let isFirstSessionForService = !firstSessionPerService[contaCorrente.CONTRATO_ID] || !firstSessionPerService[contaCorrente.CONTRATO_ID][serviceId];

                                let isFirstSessionDisabled = contaCorrente.AGENDA_ID != null || contratoAtual != 0 && contaCorrente.PARCELA == '01/01' || (foundFreeSession && !isFirstSessionForService);
                                let isSecondSessionDisabled = contaCorrente.AGENDA_ID != null || (foundFreeSession && !isFirstSessionForService);

                                if (contratoData.CONTRATO_ID != 0 && (contratoData.STATUS == 'A' || contratoData.STATUS == 'T') && contratoData.UPLOAD_CONTRATO == 'N') {
                                    //console.log('has contract without signing?', contratoData);
                                    if (!hasContractWithoutCompleteSigning.includes(contratoData.CONTRATO_ID))
                                        hasContractWithoutCompleteSigning.push(contratoData.CONTRATO_ID);
                                }

                                if (contratoAtual != contaCorrente.CONTRATO_ID) {
                                    contratoAtual = contaCorrente.CONTRATO_ID;

                                    sessionServiceLiberated[contaCorrente.CONTRATO_ID] = false;
                                    lastAvailableServiceId[contaCorrente.CONTRATO_ID] = null;
                                    availableSessionsPerService[contaCorrente.CONTRATO_ID] = {}; // Inicializa controle por serviço
                                    firstSessionPerService[contaCorrente.CONTRATO_ID] = {}; // Inicializa controle de primeira sessão por serviço

                                    //console.log(' sessionServiceLiberated[contaCorrente.CONTRATO_ID]',  sessionServiceLiberated[contaCorrente.CONTRATO_ID]);

                                    if (contratoAtual == 0) {
                                        foundFreeSession = false;
                                    } else if (contratoAtual != 0) {
                                        foundFreeSession = false;
                                    }

                                    if (contaCorrente.CONTRATO_ID == 0 && contaCorrente.AGENDA_ID == null) {
                                        habilitarInput = true;
                                    }

                                    $('#accordionInsertBusinessSchedule').append(`
                                        <div class="accordion-item">
                                            <h2 class="accordion-header" id="heading${contratoAtual}">
                                                <button class="accordion-button text-white collapsed" style="display:block !important;" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePatientContract${contratoAtual}" aria-expanded="true" aria-controls="collapsePatientContract${contratoAtual}">
                                                    ${(contratoData.STATUS == 'A' || contratoData.STATUS == 'T') && contratoData.UPLOAD_CONTRATO == 'S' && contaCorrente.CC_BLOQUEADO != 'S' && contratoAtual != 0 && !moment().isAfter(moment(contratoData.DATA_ENCERRAMENTO)) || contratoAtual == 0 ?
                                            `🟢` :
                                            ((contratoData.STATUS == 'A' || contratoData.STATUS == 'T') && contratoData.UPLOAD_CONTRATO == 'N' || contaCorrente.CC_BLOQUEADO == 'S' ?
                                                `🟡` :
                                                `🔴`)} Contrato${contratoAtual == 0 ? 's Individuais' : ` #${contratoAtual}`}</small>
                                                </button>
                                            </h2>
                                            <div id="collapsePatientContract${contratoAtual}" class="accordion-collapse collapse" aria-labelledby="heading${contratoAtual}" data-bs-parent="#accordionInsertBusinessSchedule">
                                                <div class="accordion-body js-patient-contract-table-view-${contratoAtual}">
                                                    ${contratoAtual != 0 ?
                                            `<p class="dark-text">ID: <b>${contratoAtual}</b></p>
                                                        <p class="dark-text">Doutor(a): <b>${doctorName}</b></p>
                                                        <p class="dark-text">Data de Adesão: <b>${contratoData.DATA_ADESAO}</b></p>
                                                        <p class="dark-text">Data de Encerramento: <b>${contratoData.DATA_ENCERRAMENTO}</b></p>
                                                        <p class="dark-text">Status: <b>${contaCorrente.CC_BLOQUEADO == 'S' ? 'Bloqueado' : contratoData.STATUS == 'A' && contratoData.UPLOAD_CONTRATO == 'S' ? 'Ativo' : ((contratoData.STATUS == 'A' || contratoData.STATUS == 'T') && contratoData.UPLOAD_CONTRATO == 'N' ? 'Necessário finalização das assinaturas do contrato' : 'Bloqueado ou cancelado')}</b></p>
                                                        ${contaCorrente.CC_BLOQUEADO == 'S' ? '<p class="dark-text">Motivo do Bloqueio: <b>' + contaCorrente.CC_BLOQUEADO_OBS + '</b></p>' : ''}
                                                        <p class="dark-text">Plano: <b>${contaCorrente.PLANO}</b></p>
                                                        <p class="dark-text">Serviço: <b>${serviceName}</b></p>
                                                        <p class="dark-text">Total Sessões: <b>${contratoData.sessoes.length}</b></p>`
                                            : ''}

                                                    ${(contratoData.STATUS == 'A' || contratoData.STATUS == 'T') /*&& contratoData.UPLOAD_CONTRATO == 'S'*/ && contaCorrente.CONTRATO_ID != 0 && contaCorrente.CC_BLOQUEADO != 'S' && !moment().isAfter(moment(contratoData.DATA_ENCERRAMENTO)) || contaCorrente.CONTRATO_ID == 0 && contaCorrente.CC_BLOQUEADO != 'S' ? `
                                                        <h6 class="lead dark-text">Selecione uma sessão${contratoAtual == 0 ? ' invididual' : ''}</h6>
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio" name="agenda_edit_patient_contract_session_id_and_contract_id" data-servico-id="${contaCorrente.SERVICOS_ID}" data-tipo-paciente-str="${contaCorrente.TIPO_PACIENTE}" id="flexRadioDefault${i}" value="${contaCorrente.ID}|${contaCorrente.CONTRATO_ID}" ${habilitarInput ? '' : 'disabled'}>
                                                            <label class="form-check-label" for="flexRadioDefault${i}" style="${foundFreeSession && contaCorrente.DATA_ATENDIMENTO == null && contaCorrente.STATUS == null ? '' : 'color:white !important; opacity:1;'}">
                                                                ${foundFreeSession && contaCorrente.DATA_ATENDIMENTO == null && contaCorrente.STATUS == null ? '⌛' : (contaCorrente.DATA_ATENDIMENTO == null && contaCorrente.STATUS == null ? '⌚' : '✔️')}
                                                                Parcela ${contaCorrente.PARCELA} ${contaCorrente.AGENDA_ID != null ? '<br><small>' + (contaCorrente.STATUS == 'A' ? 'Atendimento realizado em' : 'Agendado para') + ' ' + (contaCorrente.DATA_ATENDIMENTO_FORMATTED) + '</small>' : ''}
                                                                <br />Serviço: ${serviceName}
                                                                ${contratoAtual == 0 ? '<br/>Tipo do Paciente: ' + contaCorrente.TIPO_PACIENTE : ''}
                                                            </label>
                                                        </div>
                                                    ` : res.data[i].STATUS == 'A' && res.data[i].UPLOAD_CONTRATO == 'N' && contaCorrente.CONTRATO_ID != 0 ?
                                            'Necessário upload do contrato ou este lançamento está bloqueado ou cancelado.'
                                            : 'Este lançamento está bloqueado ou cancelado.'}
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    `)


                                    if (!isFirstSessionDisabled) {
                                        //sessionServiceLiberated[contaCorrente.CONTRATO_ID].push(contaCorrente.SERVICOS_ID);
                                        lastAvailableServiceId[contaCorrente.CONTRATO_ID] = contaCorrente.SERVICOS_ID;
                                        // Marca que já foi encontrada a primeira sessão para este serviço
                                        if (!firstSessionPerService[contaCorrente.CONTRATO_ID]) {
                                            firstSessionPerService[contaCorrente.CONTRATO_ID] = {};
                                        }
                                        firstSessionPerService[contaCorrente.CONTRATO_ID][serviceId] = true;
                                    }
                                } else {
                                    if (!isSecondSessionDisabled) {
                                        //sessionServiceLiberated[contaCorrente.CONTRATO_ID].push(contaCorrente.SERVICOS_ID);
                                        lastAvailableServiceId[contaCorrente.CONTRATO_ID] = contaCorrente.SERVICOS_ID;
                                        // Marca que já foi encontrada a primeira sessão para este serviço
                                        if (!firstSessionPerService[contaCorrente.CONTRATO_ID]) {
                                            firstSessionPerService[contaCorrente.CONTRATO_ID] = {};
                                        }
                                        firstSessionPerService[contaCorrente.CONTRATO_ID][serviceId] = true;
                                    }

                                    if (contaCorrente.CONTRATO_ID == 0 && contaCorrente.AGENDA_ID == null) {
                                        habilitarInput = true;
                                    }

                                    // Lógica removida - agora cada serviço pode ter sua própria sessão disponível
                                    // if (foundFreeSession && contratoData.DATA_ATENDIMENTO == null && contaCorrente.SERVICOS_ID != lastAvailableServiceId[contaCorrente.CONTRATO_ID] && !sessionServiceLiberated[contaCorrente.CONTRATO_ID]) {
                                    //     foundFreeSession = false;
                                    //     lastAvailableServiceId[contaCorrente.CONTRATO_ID] = null;
                                    //     sessionServiceLiberated[contaCorrente.CONTRATO_ID] = true;
                                    // }

                                    if ((contratoData.STATUS == 'A' || contratoData.STATUS == 'T') && contratoData.UPLOAD_CONTRATO == 'S' && contaCorrente.CONTRATO_ID != 0 && contaCorrente.CC_BLOQUEADO != 'S' && !moment().isAfter(moment(contratoData.DATA_ENCERRAMENTO)) || contaCorrente.CONTRATO_ID == 0 && contaCorrente.CC_BLOQUEADO != 'S') {
                                        $('.js-patient-contract-table-view-' + contratoAtual).append(`
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="agenda_edit_patient_contract_session_id_and_contract_id" data-servico-id="${contaCorrente.SERVICOS_ID}" data-tipo-paciente-str="${contaCorrente.TIPO_PACIENTE}" id="flexRadioDefault${i}" value="${contaCorrente.ID}|${contaCorrente.CONTRATO_ID}" ${habilitarInput ? '' : 'disabled'}>
                                                <label class="form-check-label" for="flexRadioDefault${i}" style="${foundFreeSession && contaCorrente.DATA_ATENDIMENTO == null && contaCorrente.STATUS == null ? '' : 'color:white !important; opacity:1;'}">
                                                    ${foundFreeSession && contaCorrente.DATA_ATENDIMENTO == null && contaCorrente.STATUS == null ? '⌛' : (contaCorrente.DATA_ATENDIMENTO == null && contaCorrente.STATUS == null ? '⌚' : '✔️')}
                                                    Parcela ${contaCorrente.PARCELA} ${contaCorrente.AGENDA_ID != null ? '<br><small>' + (contaCorrente.STATUS == 'A' ? 'Atendimento realizado em' : 'Agendado para') + ' ' + (contaCorrente.DATA_ATENDIMENTO_FORMATTED) + '</small>' : ''}
                                                    <br />Serviço: ${serviceName}
                                                    ${contratoAtual == 0 ? '<br/>Tipo do Paciente: ' + contaCorrente.TIPO_PACIENTE : ''}
                                                </label>
                                            </div>
                                        `);
                                    } else if (
                                        (contratoData.STATUS == 'A' || contratoData.STATUS == 'T') && contratoData.UPLOAD_CONTRATO == 'N' && contaCorrente.CONTRATO_ID != 0 && contaCorrente.CC_BLOQUEADO != 'S'
                                    ) {
                                        // aviso que só pode agendar 1 sessão antnes de completar as assinaturas do contrato
                                        $('.js-patient-contract-table-view-' + contratoAtual).append(`
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="agenda_edit_patient_contract_session_id_and_contract_id" data-servico-id="${contaCorrente.SERVICOS_ID}" data-tipo-paciente-str="${contaCorrente.TIPO_PACIENTE}" id="flexRadioDefault${i}" value="${contaCorrente.ID}|${contaCorrente.CONTRATO_ID}" disabled>
                                                <label class="form-check-label" for="flexRadioDefault${i}" style="color:white !important; opacity:1;">
                                                    🟡 Necessário finalização das assinaturas do contrato
                                                </label>
                                            </div>
                                        `);
                                    }
                                }

                                if (contratoAtual != 0 && contaCorrente.DATA_ATENDIMENTO == null && contaCorrente.STATUS == null && contaCorrente.PARCELA != '01/01' && contaCorrente.AGENDA_ID == null) {
                                    foundFreeSession = true;
                                }

                                //console.log('sessionServiceLiberated', sessionServiceLiberated);

                                htmlInsrt += `
                                `;
                            }

                            console.log('availableSessionsPerService', availableSessionsPerService);
                            console.log('firstSessionPerService', firstSessionPerService);
                            console.log('liberouSessaoFutura', liberouSessaoFutura);

                            //console.log('hasContractWithoutCompleteSigning', hasContractWithoutCompleteSigning);
                            if (hasContractWithoutCompleteSigning.length > 0) {
                                $('.js-edit-agenda-customer-current-account-launch').removeClass('js-current-account-add-transaction');
                                $('.js-edit-agenda-customer-current-account-launch').prop('disabled', true);
                                $('.js-edit-agenta-customer-alert').removeClass('d-none');
                                $('.js-edit-agenta-customer-alert').html(`
                                    <div class="alert alert-danger mb-2 mb-2" role="alert">
                                        Este paciente possui ${hasContractWithoutCompleteSigning.length} contratos sem finalizar as assinaturas. E por isso não é possível lançar sessões individuais.
                                    </div>
                                `);
                            }

                            // Verifica se não é hunter e se tem filial GOIANIA
                            if (liberouSessaoFutura && !userHasRole('SELLER') && self.updateModalDataObj.obj.FILIAL_ID == 14) {
                                let result = self.checkIfHasAnyContractWithTwoServicesAvailable(liberouSessaoFutura);
                                //console.log('result', result);
                                if (result) {
                                    $('.js-want-schedule-massage-too').removeClass('d-none');
                                    //$('#agenda_edit_massage_therapist').prop('required', true);
                                    //$('#agenda_edit_massage_therapist').attr('required', true);
                                    $('#agenda_edit_customer_schedule_massage').prop('checked', false);
                                    $('#agenda_edit_massage_therapist').val('');
                                } else {
                                    $('.js-want-schedule-massage-too').addClass('d-none');
                                    //$('#agenda_edit_massage_therapist').prop('required', false);
                                    //$('#agenda_edit_massage_therapist').attr('required', false);
                                    $('#agenda_edit_customer_schedule_massage').prop('checked', false);
                                    $('#agenda_edit_massage_therapist').val('');
                                }
                            } else {
                                $('.js-want-schedule-massage-too').addClass('d-none');
                                //$('#agenda_edit_massage_therapist').prop('required', false);
                                //$('#agenda_edit_massage_therapist').attr('required', false);
                                $('#agenda_edit_customer_schedule_massage').prop('checked', false);
                                $('#agenda_edit_massage_therapist').val('');
                            }

                            if (res.data.length === 0) {
                                $(".js-agenda-edit-manager-select-contract-container").html(`Este paciente não possui nenhum conta corrente de sessões ou individuais.`);
                            }
                        }
                    },
                    errorCallback: function (err) {
                        $(".modal-update-event-manager-dialog").unblock();
                        //$(".modal-update-event-manager-dialog").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                        console.error('ERROR', 'crud_agenda_admin.js/patient/contract', '.js-business-scheduler', err);
                    }
                })


            }
        });

        $(document).on('click', '.js-agenda-edit-schedule-doctor-button', function () {
            let newDoctorId = $('#agenda_edit_doctor').val();
            let newDoctorName = $('#agenda_edit_doctor option:selected').text();
            $('.js-agenda-edit-schedule-doctor-button').prop('disabled', true);

            Swal.fire({
                title: 'Deseja realmente alterar o doutor para ' + newDoctorName + '?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, alterar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    console.log('newDoctorId', newDoctorId);
                    //$('.js-agenda-edit-schedule-doctor-button').prop('disabled', false);
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/agenda/doctor_migrate_single_schedule',
                        data: {
                            agendaId: self.updateModalDataObj.id,
                            doctorId: newDoctorId,
                            serviceId: $('#agenda_edit_service').val(),
                        },
                        successCallback: function (res) {
                            console.log('res', res);

                            if (res.error) {
                                $('.js-agenda-edit-schedule-doctor-button').prop('disabled', false);
                                Swal.fire({
                                    title: 'Erro ao alterar o doutor',
                                    text: res.message,
                                    icon: 'error',
                                    confirmButtonText: 'Ok',
                                });
                            } else {
                                $('#agenda_edit_doctor').attr('readonly', true);
                                $('.js-agenda-edit-schedule-doctor-button').addClass('d-none');
                                Swal.fire({
                                    title: 'Doutor alterado com sucesso',
                                    text: 'O doutor foi alterado com sucesso',
                                    icon: 'success',
                                    confirmButtonText: 'Ok',
                                });
                            }
                        },
                        errorCallback: function (err) {
                            $('.js-agenda-edit-schedule-doctor-button').prop('disabled', false);
                            console.error('ERROR', 'crud_agenda_admin.js/agenda/edit/doctor', '.js-agenda-edit-schedule-doctor-button', err);
                        }
                    });

                } else {
                    $('.js-agenda-edit-schedule-doctor-button').prop('disabled', false);
                }
            });
        });

        // Detecta seleção de contrato e sessão do paciente
        $(document).on('click', 'input[name="agenda_edit_patient_contract_session_id_and_contract_id"]', function () {
            let servicoId = $(this).data('servico-id');
            $('#agenda_edit_service').val(servicoId);
            $('#agenda_edit_service').trigger('change');
            $('#agenda_edit_service').attr('readonly', true);
            $('.js-agenda-edit-post-patient').removeClass('d-none');
            //self.patientType = $(this).data('tipo-paciente-str');
            //console.log('seleciona conta corrente tipo de paciente',  self.patientType);
        });

        // Detecta clique no botão de limpar campo do paciente já selecionado
        $(document).on('click', '.js-agenda-edit-manager-clear-selected-patient', function () {
            $('.js-edit-agenta-customer-alert').addClass('d-none');
            $('.js-edit-agenda-customer-current-account-launch').addClass('js-current-account-add-transaction');

            self.agendaInsertExistingCustomer = false;
            $('#agenda_edit_search_customer').val('').trigger('change')
            //$('#agenda_edit_service').val('');
            $('.js-agenda-edit-manager-currenct-account-transaction-container').addClass('d-none');
            $(".js-agenda-edit-manager-select-contract-container").html(``);
            $('.js-agenda-edit-post-patient').addClass('d-none');
            $('#agenda_edit_customer_name').val('');
            $('#agenda_edit_customer_whatsapp').val('');
            $('#agenda_edit_customer_profession').val('');
            $('#agenda_edit_customer_name').attr('readonly', false);
            $('#agenda_edit_customer_whatsapp').attr('readonly', false);
            $('#agenda_edit_customer_origin').attr('readonly', false);
            $('#agenda_edit_customer_profession').attr('readonly', false);
            $('#agenda_edit_customer_origin').val('');

            /*if (self.agendaInsertData.step == 5) {
                hideCurrentAgendaInsertStep();
                self.agendaInsertData.step = 4;
            }*/
        });

        // Detecta usuário selecionando a Filial
        $(document).on('change', '#agenda_edit_business_branch', function () {
            let currentBranchValue = $(this).val();
            // Caso não tenha selecionado uma filial
            if (currentBranchValue == '') {
                $('#agenda_edit_doctor').prop('disabled', true);  // Desativa campo do "Doutor"
            } else {
                // Caso tenha selecionado uma filial
                // Desativa campo "Filial" e ativa "Doutor"
                //$('#agenda_edit_business_branch').prop('disabled', true);
                $('#agenda_edit_doctor').prop('disabled', false);

                // Caso troque de filial e tenha um doutor selecionado, esconde passos antigos e configura passo atual
                let currentDoctorValue = $('#agenda_edit_doctor').val();
            }

            console.log('currentBranchValue', currentBranchValue);
            if (currentBranchValue == ('GOIANIA' || '14')) {
                //initializeFaceAPI();
            }
        });

        // Detecta usuário selecionando o Doutor
        $(document).on('change', '#agenda_edit_doctor', function () {
            let currentDoctorValue = $(this).val();
            // Caso não tenha selecionado um Doutor
            if (currentDoctorValue == '') {
                $('#agenda_edit_doctor').prop('disabled', true);
            } else {

                // Caso possua uma data de consulta configurada
                // realiza busca pelos horários edisponíveis
                let currentDate = $('#agenda_edit_date').val();
                if (currentDate != '') {
                    $('#agenda_edit_date').trigger('change');
                }
            }
        });

        // Detecta usuário selecionando a Data
        $(document).on('change', '#agenda_edit_date', function () {
            let currentAgendaEditDate = $(this).val();

            // Verifica se o campo de Doutor está com um Doutor selecionado
            if ($("#agenda_edit_doctor").val() === '') {
                $('#agenda_edit_doctor').prop('disabled', true);
                return;
            }

            // Resgata horários disponíveis do Doutor
            /*apiCall({
                method: 'GET',
                endpoint: 'api/v1/doctor/agenda',
                data: {
                    hourId: self.updateModalDataObj.id,
                    /*doctorId: parseInt($("#agenda_edit_doctor option:selected").val().trim()),
                    branchId: parseInt($("#agenda_edit_business_branch option:selected").val().trim()),
                    date: currentAgendaEditDate,
                    full_agenda: 1*
                },
                successCallback: function(res) {
                    console.log('dashboard.js/doctor/agenda', '#agenda_edit_date', res);

                    $(".modal-update-event-manager-dialog").unblock();

                    if (res.error) {

                    } else {
                        // Configura horários disponíveis
                        let html = '<option selected default value="">-- Selecione --</option>';
                        for(let i in res.data) {*/
            setTimeout(() => $(".modal-update-event-manager-dialog").unblock(), 1000);
            let html = '<option selected default value="">-- Selecione --</option>';
            let avaiDoctorHour = self.updateModalDataObj.obj;

            /*if (!avaiDoctorHour.HORA_INICIO_FORMATED) {
                console.error('[crud_agenda_hunter:edit] avaiDoctorHour', avaiDoctorHour);
                continue;
            }*/

            let
                selectedStartDate = $('#agenda_edit_date').val(),
                todayDate = moment().tz('America/Sao_Paulo'),
                selectedStartDateMoment = moment(selectedStartDate).tz('America/Sao_Paulo'),
                startHourMinute = avaiDoctorHour.HORA_INICIO_FORMATED.split(':'),
                startDate = selectedStartDateMoment.set({ 'hours': parseInt(startHourMinute[0]), 'minutes': parseInt(startHourMinute[1]), 'seconds': 0 }),
                isDisabled = false;

            if (selectedStartDateMoment.format('YYYY-MM-DD') == todayDate.format('YYYY-MM-DD') &&
                todayDate.unix() > startDate.unix()) {
                isDisabled = true;
            }

            html += `
                                <option value="${avaiDoctorHour.HORA_INICIO_FORMATED}" data-agenda-id="${avaiDoctorHour.ID}" ${self.updateModalDataObj?.obj?.ID == avaiDoctorHour.ID ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}>
                                    ${avaiDoctorHour.CATEGORIA} | ${avaiDoctorHour.HORA_INICIO_FORMATED}
                                </option>
                            `;
            //}
            $('#agenda_edit_start_hour').prop('disabled', false);
            $('#agenda_edit_start_hour').html(html);
            $('#agenda_edit_start_hour').trigger('change');

            $('#agenda_edit_service').prop('disabled', false);

            html = '<option selected default value="">-- Selecione --</option>';
            for (let i = 0; i < self.operatorAllowedServices.length; ++i) {
                let serviceObj = self.operatorAllowedServices[i];
                let servicoSelecionado = self.updateModalDataObj.obj.SERVICOS ? self.updateModalDataObj.obj.SERVICOS.toLowerCase().trim() : '';
                html += `
                                <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" data-info='${JSON.stringify(serviceObj)}' data-patient-type-id="${serviceObj.TIPO_PACIENTE_ID}" ${self.updateModalDataObj.obj.SERVICOS ? (serviceObj.SERVICO.toLowerCase().trim() == servicoSelecionado ? 'selected' : '') : ''}>${serviceObj.SERVICO}</option>
                            `;
            }
            $('#agenda_edit_service').prop('disabled', false);
            $('#agenda_edit_service').html(html);
            $('#agenda_edit_service').trigger('change');
            /*apiCall({
                method: 'GET',
                endpoint: 'api/v1/employee/services',
                successCallback: function(res) {
                    console.log('dashboard.js/employee/services', '#agenda_edit_date', res);
 
                    if (res.error) {
                        
                    } else {
                        let html = '<option selected default value="">-- Selecione --</option>';
                        for(let i in res.data) {
                            let serviceObj = res.data[i];
                            html += `
                                <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" ${self.updateModalDataObj.obj.SERVICOS ? (serviceObj.SERVICO.toLowerCase().trim() == self.updateModalDataObj.obj.SERVICOS.toLowerCase().trim() ? 'selected' : '') : ''}>${serviceObj.SERVICO}</option>
                            `;
                        }
                        $('#agenda_edit_service').prop('disabled', false);
                        $('#agenda_edit_service').html(html);
                        $('#agenda_edit_service').trigger('change');
                    }
                },
                errorCallback(err) {
                    console.error('ERROR', 'dashboard.js/employee/services', '#agenda_edit_date', err);
                }
            });*/

            if (self.updateModalDataObj.obj.CLIENTE_DADOS) {
                let dadosCliente = self.updateModalDataObj.obj.CLIENTE_DADOS.split("|");

                if (dadosCliente.length > 0) {
                    if (dadosCliente[0].trim() != '')
                        $('#agenda_edit_customer_name').val(dadosCliente[0]);
                    if (dadosCliente[1].trim() != '')
                        self.customerEditWhatsappInput.setNumber(dadosCliente[1]);
                }
            }
            //}
            /*},
            errorCallback(err) {
                $(".modal-update-event-manager-dialog").unblock();
                console.error('ERROR', 'dashboard.js/doctor/agenda', '#agenda_edit_date', err);
            }
        });*/


        });

        $(document).on('change', 'input[name="agenda_edit_is_first_appoitment"]', function () {
            let isFirstAppoitment = $(this).val();
            //console.log('isFirstAppoitment', isFirstAppoitment);
            console.log('self.updateModalDataObj', self.updateModalDataObj);

            if (isFirstAppoitment == 'N') {
                $('.js-agenda-edit-search-existing-patient').removeClass('d-none');
                $('.js-agenda-edit-post-patient').addClass('d-none');
                $('.js-agenda-edit-post-service').addClass('d-none');
            } else {
                if (self.updateModalDataObj.obj.TIPO_PACIENTE == 'PR') {
                    $('#agenda_edit_is_first_appointment_yes').trigger('click');
                    return window.toast({
                        error: true,
                        text: "Não é possível lançar sessão individual para um paciente que não possui cadastro."
                    });
                }
                $('.js-agenda-edit-search-existing-patient').addClass('d-none');
                $('.js-agenda-edit-manager-clear-selected-patient').trigger('click');
                $('.js-agenda-edit-post-patient').removeClass('d-none');
                $('.js-agenda-edit-post-service').removeClass('d-none');
                $('#agenda_edit_service').attr('readonly', false);
                $('#agenda_edit_service').val('');
            }
            //
        });

        // Detecta usuário selecionando tipo de serviço
        $(document).on('change', '#agenda_edit_service', function () {
            let serviceName = $(this).val(),
                serviceNameMinimumTime = $('#agenda_edit_service option:selected').data('service-time'),
                selectedStartDate = $('#agenda_edit_date').val(),
                selectedStartHour = $('#agenda_edit_start_hour option:selected').val().trim(),
                patientTypeId = $('#agenda_edit_service option:selected').data('patient-type-id');

            // Caso seja um tipo de serviço válido, cálcula tempo de término
            // e mostra botão de inserção
            if (serviceName != '') {
                let
                    todayDate = moment().tz('America/Sao_Paulo'),
                    selectedStartDateMoment = moment(selectedStartDate).tz('America/Sao_Paulo'),
                    startHourMinute = selectedStartHour.split(':'),
                    startDate = selectedStartDateMoment.set({ 'hours': parseInt(startHourMinute[0]), 'minutes': parseInt(startHourMinute[1]), 'seconds': 0 });

                // check if updatemodalobj 
                //console.log('updatemodalobj', self.updateModalDataObj);
                //console.log('patientTypeId', patientTypeId);

                /*if (self.updateModalDataObj.obj.CLIENTES_ID == null && self.updateModalDataObj.obj.TIPO_PACIENTE_ID != patientTypeId) {
                    window.toast({
                        error: true,
                        text: 'Este serviço não é permitido nesse horário.'
                    });
                    $('.js-agenda-edit-post-service').addClass('d-none');
                    return $('#agenda_edit_service').val('');
                }*/

                $('#agenda_edit_end_hour').val(startDate.add('minutes', serviceNameMinimumTime).format('HH:mm'))
                //$('.js-agenda-edit-post-service').removeClass('d-none')
            } else {
                $('#agenda_edit_end_hour').val('');
                //$('.js-agenda-edit-post-service').addClass('d-none');
            }
        });

        // Detecta usuário clicando em opção para "Reagendar" ou "Cancelar"
        $(document).on('click', '.js-manager-update-schedule-event', function () {
            let eventType = $(this).data("type");
            let data = $('.js-business-scheduler-update').serializeArray(),
                scheduleSelectedAgendaId = $('#agenda_edit_start_hour option:selected').data('agenda-id');

            data.push({
                name: 'agenda_edit_schedule_agenda_id',
                value: scheduleSelectedAgendaId
            });
            data.push({
                name: 'agenda_edit_customer_whatsapp_int',
                value: self.customerEditWhatsappInput.getNumber()
            });
            data.push({
                name: 'agenda_edit_patient_type',
                value: self.patientType
            });
            if (self.agendaEditExistingCustomer) {
                data.push({
                    name: 'agenda_edit_existing_customer',
                    value: self.agendaEditExistingCustomer
                });
            }

            let selfBtn = this;

            switch (eventType) {
                case 'EnviarMensagem': {
                    let url = 'https://web.whatsapp.com/send/?text&type=phone_number&app_absent=0&' + $.param({
                        phone: `55${self.customerEditWhatsappInput.getNumber()}`
                    });
                    window.open(url, '_blank');
                    break;
                }
                case 'AcessarCadastro': {
                    let patientId = self.updateModalDataObj.obj.CLIENTES_ID;
                    let patientBranch = $('#agenda_edit_business_branch option:selected').text();
                    let url = getBaseDir() + 'pacientes/cadastros?' + $.param({
                        patient_id: patientId,
                        branch: patientBranch
                    });
                    window.open(url, '_blank');
                    break;
                }
                case 'MarcarContaCorrentePago': {
                    //console.log('Marcar conta corrente como pago', data);

                    Swal.fire({
                        title: 'Marcar conta corrente como pago',
                        text: "Você tem certeza que deseja marcar a conta corrente como paga?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sim, marcar como pago!',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $(".modal-update-event-manager").block();
                            $(selfBtn).prop('disabled', true)
                            apiCall({
                                method: 'POST',
                                endpoint: 'api/v1/doctor/agenda/mark_current_account_as_paid',
                                data,
                                successCallback: function (res) {
                                    console.log('crud_agenda_admin.js/doctor/agenda/mark_current_account_as_paid', '.js-manager-update-schedule-event', res);
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)

                                    if (res.error) {
                                        window.toast({
                                            error: true,
                                            text: res.message
                                        })

                                        Swal.fire({
                                            title: 'Erro ao marcar conta corrente como paga',
                                            text: res.message,
                                            icon: 'error',
                                            showConfirmButton: false
                                        });
                                    } else {
                                        window.toast({
                                            error: false,
                                            text: res.message
                                        })
                                        $('.js-update-event-manager-dialog-close').trigger('click');
                                        $("#calendar").block(window._loader.loading);
                                        self.bindAgendaData(true);

                                        Swal.fire({
                                            title: 'Conta corrente marcada como paga',
                                            text: res.message,
                                            icon: 'success',
                                            showConfirmButton: false
                                        });
                                    }
                                },
                                errorCallback: function (err) {
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)
                                    //$(".modal-update-event-manager").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                                    console.error('ERROR', 'crud_agenda_admin.js/doctor/agenda/mark_current_account_as_paid', '.js-manager-update-schedule-event', err);
                                }
                            })
                        }
                    });
                    break;
                }
                case 'Presente': {
                    //console.log('Marcar como presente', data);
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'NAO_COMPARECEU')
                        return window.toast({ error: true, text: "Não é possível marcar como presente, pois este agendamento que foi marcado como 'Não Compareceu'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'CANCELADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Presente', pois este agendamento que já foi cancelado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'REAGENDADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Presente', pois este agendamento que já foi reagendado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'Presente')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Presente', pois este paciente já foi marcado como 'Presente'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'ATENDIDO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Presente', pois este paciente já foi marcado como 'Atendido'." });

                    let role = getPatientRoleByPatientType(self.patientType);
                    if (role === 'PACIENTE_NOVO' && (self.updateModalDataObj.obj.CLIENTE_CADASTRO_FINALIZADO == null || self.updateModalDataObj.obj.CLIENTE_CADASTRO_FINALIZADO == 'N')) {
                        if (window.confirm('Parece que este é um Paciente Novo, você será redirecionado(a) para finalização de cadastro e lançamento de conta corrente, ok?')) {
                            let patientId = self.updateModalDataObj.obj.CLIENTES_ID;
                            let patientBranch = $('#agenda_edit_business_branch option:selected').text();
                            // open new tab with
                            let url = getBaseDir() + 'pacientes/cadastros?' + $.param({
                                patient_id: patientId,
                                branch: patientBranch
                            });
                            //window.open(url, '_blank');
                            location.href = url;
                        }
                    } else {
                        let patientBranchId = $('#agenda_edit_business_branch option:selected').val();

                        let endOfContactPatientsHtml = '';
                        //console.log('self.updateModalDataObj.obj',self.updateModalDataObj.obj);
                        if (self.updateModalDataObj.obj.SESSOES_REALIZADAS) {
                            if (self.updateModalDataObj.obj.PARCELA != '01/01') {
                                let sessoes = self.updateModalDataObj.obj.SESSOES_REALIZADAS.split('/');
                                if ((sessoes[1] - sessoes[0]) <= 5) {
                                    endOfContactPatientsHtml = 'ATENÇÃO: Este paciente está finalizando o tratamento. Trabalhar upgrade/manutenção.';
                                }
                            }
                        }

                        Swal.fire({
                            title: 'Marcar como presente',
                            html: `Você tem certeza que deseja marcar como presente? ${endOfContactPatientsHtml ? `<br><br><span class="text-danger">${endOfContactPatientsHtml}</span>` : ''}`,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim, marcar como presente!',
                            cancelButtonText: 'Cancelar'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                let hasPresentOrAttendedTodayAlready = false;
                                /*if (patientBranchId == 14 && (userHasRole('MANAGER') || userHasRole('COMMERCIAL_ASSISTANT') || userHasRole('DOCTOR') || userHasRole('DOCTOR_2'))) {
                                    //console.log('self.EVENTS_LIST', self.EVENTS_LIST);
                                    for (let i = 0; i < self.EVENTS_LIST.length; i++) {
                                        let agendaScheduleInfo = self.EVENTS_LIST[i];
                                        if (!agendaScheduleInfo)
                                            continue;

                                        //onsole.log('agendaScheduleInfo.obj.CLIENTES_ID', agendaScheduleInfo.obj.CLIENTES_ID);
                                        //console.log('self.updateModalDataObj.obj.CLIENTES_ID', self.updateModalDataObj.obj.CLIENTES_ID);
                                        //console.log('=====================================================================');
                                        if (
                                            agendaScheduleInfo.obj.CLIENTES_ID == self.updateModalDataObj.obj.CLIENTES_ID
                                            && (agendaScheduleInfo.obj.CATEGORIA == 'Presente' || agendaScheduleInfo.obj.CATEGORIA == 'Atendido')
                                        ) {
                                            hasPresentOrAttendedTodayAlready = true;
                                            break;
                                        }
                                    }

                                    if (!hasPresentOrAttendedTodayAlready) {
                                        if (self.updateModalDataObj.obj.FACE_DESCRIPTORS) {
                                            $(document).find('.js-start-facial-recognition[data-patient-id="' + self.updateModalDataObj.obj.CLIENTES_ID + '"]').first().trigger('click');
                                        } else {
                                            $(document).find('.js-open-capture-patient[data-patient-id="' + self.updateModalDataObj.obj.CLIENTES_ID + '"]').first().trigger('click');
                                        }
                                        //const protocolUrl = `ajustar://login?token=${window._sessionData.accessToken}&branchId=14&startRecognition=true`;
                                        //window.open(`${protocolUrl}`, '_blank').focus();
                                        return;
                                    }
                                }*/

                                console.log('hasPresentOrAttendedTodayAlready', hasPresentOrAttendedTodayAlready);
                                //return;

                                $(".modal-update-event-manager").block();
                                $(selfBtn).prop('disabled', true)
                                apiCall({
                                    method: 'POST',
                                    endpoint: 'api/v1/doctor/agenda/mark_as_present',
                                    data,
                                    successCallback: function (res) {
                                        console.log('crud_agenda_admin.js/doctor/agenda/mark_as_present', '.js-manager-update-schedule-event', res);
                                        $(".modal-update-event-manager").unblock();
                                        $(selfBtn).prop('disabled', false)

                                        if (res.error) {
                                            window.toast({
                                                error: true,
                                                text: res.message
                                            })

                                            Swal.fire({
                                                title: 'Erro ao marcar como presente',
                                                text: res.message,
                                                icon: 'error',
                                                showConfirmButton: false
                                            });
                                        } else {
                                            window.toast({
                                                error: false,
                                                text: res.message
                                            })
                                            $('.js-update-event-manager-dialog-close').trigger('click');
                                            $("#calendar").block(window._loader.loading);
                                            self.bindAgendaData(true);

                                            Swal.fire({
                                                title: 'Paciente marcado como presente',
                                                text: res.message,
                                                icon: 'success',
                                                showConfirmButton: false
                                            });
                                        }
                                    },
                                    errorCallback: function (err) {
                                        $(".modal-update-event-manager").unblock();
                                        $(selfBtn).prop('disabled', false)
                                        //$(".modal-update-event-manager").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                                        console.error('ERROR', 'crud_agenda_admin.js/doctor/agenda/mark_as_present', '.js-manager-update-schedule-event', err);
                                    }
                                })
                            }
                        });
                    }
                    break;
                }
                case 'Confirmado': {
                    //console.log('Marcar como confirmado', data);
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'NAO_COMPARECEU')
                        return window.toast({ error: true, text: "Não é possível marcar como Confirmado um agendamento que foi marcado como 'Não Compareceu'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'CANCELADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Confirmado' um agendamento que já foi cancelado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'REAGENDADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Confirmado' um agendamento que já foi reagendado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'Confirmado')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Confirmado' um agendamento que já foi confirmado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'ATENDIDO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Confirmado', pois este paciente já foi marcado como 'Atendido'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'Presente')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Confirmado', pois este paciente já foi marcado como 'Presente'." });

                    Swal.fire({
                        title: 'Marcar como confirmado',
                        text: "Você tem certeza que deseja marcar como confirmado?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sim, marcar como confirmado!',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $(".modal-update-event-manager").block();
                            $(selfBtn).prop('disabled', true)
                            apiCall({
                                method: 'POST',
                                endpoint: 'api/v1/doctor/agenda/mark_as_confirmed',
                                data,
                                successCallback: function (res) {
                                    console.log('crud_agenda_admin.js/doctor/agenda/mark_as_confirmed', '.js-manager-update-schedule-event', res);
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)

                                    if (res.error) {
                                        window.toast({
                                            error: true,
                                            text: res.message
                                        })

                                        Swal.fire({
                                            title: 'Erro ao marcar como confirmado',
                                            text: res.message,
                                            icon: 'error',
                                            showConfirmButton: false
                                        });
                                    } else {
                                        window.toast({
                                            error: false,
                                            text: res.message
                                        })
                                        $('.js-update-event-manager-dialog-close').trigger('click');
                                        $("#calendar").block(window._loader.loading);
                                        self.bindAgendaData(true);

                                        Swal.fire({
                                            title: 'Paciente marcado como confirmado',
                                            text: res.message,
                                            icon: 'success',
                                            showConfirmButton: false
                                        });
                                    }
                                },
                                errorCallback: function (err) {
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)
                                    //$(".modal-update-event-manager").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                                    console.error('ERROR', 'crud_agenda_admin.js/doctor/agenda/mark_as_confirmed', '.js-manager-update-schedule-event', err);
                                }
                            })
                        }
                    });
                    break;
                }
                case 'Reagendado': {
                    //console.log('Clicando para regandar', data)
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'NAO_COMPARECEU')
                        return window.toast({ error: true, text: "Não é possível marcar um Reagendamento que foi marcado como 'Não Compareceu'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'CANCELADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Reagendado' um agendamento que já foi cancelado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'REAGENDADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Reagendado' um agendamento que já foi reagendado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'ATENDIDO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Reagendado', pois este paciente já foi marcado como 'Atendido'." });


                    self.agendaRescheduleCache = data;
                    $("#modal-agenda-reschedule").modal('show');
                    let reSchedulment = new AgendaReschedule(data, function (response) {
                        //console.log('reschedule response', response);
                        if (response) {
                            $('.js-update-event-manager-dialog-close').trigger('click');
                            $("#calendar").block(window._loader.loading);
                            self.bindAgendaData(true);
                        }
                    });
                    break;
                }
                case 'Não Compareceu': {
                    //console.log('Clicando para Não Compareceu', data)
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'NAO_COMPARECEU')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Não Compareceu' um agendamento que já foi marcado como 'Não Compareceu'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'CANCELADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Não Compareceu' um agendamento que já foi cancelado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'Presente')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Não Compareceu' um agendamento que já foi marcado como 'Presente'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'REAGENDADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Não Compareceu' um agendamento que já foi marcado como 'Reagendado'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'ATENDIDO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Não Compareceu', pois este paciente já foi marcado como 'Atendido'." });

                    Swal.fire({
                        title: 'Marcar como Não Compareceu',
                        text: "Você tem certeza que deseja marcar como Não Compareceu?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sim, marcar como Não Compareceu!',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $(".modal-update-event-manager").block();
                            $(selfBtn).prop('disabled', true)
                            apiCall({
                                method: 'POST',
                                endpoint: 'api/v1/doctor/agenda/mark_as_not_attended',
                                data,
                                successCallback: function (res) {
                                    console.log('crud_agenda_admin.js/doctor/agenda/mark_as_not_attended', '.js-manager-update-schedule-event', res);
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)

                                    if (res.error) {
                                        window.toast({
                                            error: true,
                                            text: res.message
                                        })

                                        Swal.fire({
                                            title: 'Erro ao marcar como Não Compareceu',
                                            text: res.message,
                                            icon: 'error',
                                            showConfirmButton: false
                                        });
                                    } else {
                                        window.toast({
                                            error: false,
                                            text: res.message
                                        })
                                        $('.js-update-event-manager-dialog-close').trigger('click');
                                        $("#calendar").block(window._loader.loading);
                                        self.bindAgendaData(true);

                                        Swal.fire({
                                            title: 'Paciente marcado como Não Compareceu',
                                            text: res.message,
                                            icon: 'success',
                                            showConfirmButton: false
                                        });
                                    }
                                },
                                errorCallback: function (err) {
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)
                                    //$(".modal-update-event-manager").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                                    console.error('ERROR', 'crud_agenda_admin.js/doctor/agenda/mark_as_not_attended', '.js-manager-update-schedule-event', err);
                                }
                            })
                        }
                    });
                    break;
                }
                case 'Cancelado': {
                    //console.log('Clicando para Cancelar', data)
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'NAO_COMPARECEU')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Cancelado' um agendamento que foi marcado como 'Não Compareceu'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'CANCELADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Cancelado' de um agendamento que já foi cancelado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'REAGENDADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Cancelado' de um agendamento que já foi reagendado." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'ATENDIDO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Cancelado', pois este paciente já foi marcado como 'Atendido'." });

                    Swal.fire({
                        title: 'Marcar como Cancelado',
                        text: "Você tem certeza que deseja marcar como Cancelado?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sim, marcar como Cancelado!',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $(".modal-update-event-manager").block();
                            $(selfBtn).prop('disabled', true)
                            apiCall({
                                method: 'POST',
                                endpoint: 'api/v1/doctor/agenda/mark_as_cancelled',
                                data,
                                successCallback: function (res) {
                                    console.log('crud_agenda_admin.js/doctor/agenda/mark_as_cancelled', '.js-manager-update-schedule-event', res);
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)

                                    if (res.error) {
                                        window.toast({
                                            error: true,
                                            text: res.message
                                        })

                                        Swal.fire({
                                            title: 'Erro ao marcar como Cancelado',
                                            text: res.message,
                                            icon: 'error',
                                            showConfirmButton: false
                                        });
                                    } else {
                                        window.toast({
                                            error: false,
                                            text: res.message
                                        })
                                        $('.js-update-event-manager-dialog-close').trigger('click');
                                        $("#calendar").block(window._loader.loading);
                                        self.bindAgendaData(true);

                                        Swal.fire({
                                            title: 'Paciente marcado como Cancelado',
                                            text: res.message,
                                            icon: 'success',
                                            showConfirmButton: false
                                        });
                                    }
                                },
                                errorCallback: function (err) {
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)
                                    //$(".modal-update-event-manager").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                                    console.error('ERROR', 'crud_agenda_admin.js/doctor/agenda/mark_as_cancelled', '.js-manager-update-schedule-event', err);
                                }
                            })
                        }
                    });
                    break;
                }
                case 'Excluir horário': {
                    //console.log('Clicando para Exluir horário', data)

                    Swal.fire({
                        title: 'Excluir horário da Agenda',
                        text: "Você tem certeza que deseja excluir o Horário da Agenda? Essa ação não poderá ser desfeita.",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancelar',
                        confirmButtonText: 'Sim, excluir horário!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $(".modal-update-event-manager").block();
                            $(selfBtn).prop('disabled', true)
                            apiCall({
                                method: 'POST',
                                endpoint: 'api/v1/doctor/agenda/delete',
                                data,
                                successCallback: function (res) {
                                    console.log('crud_agenda_admin.js/doctor/agenda/delete', '.js-manager-update-schedule-event', res);
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)

                                    if (res.error) {
                                        window.toast({
                                            error: true,
                                            text: res.message
                                        })

                                        Swal.fire({
                                            title: 'Erro ao excluir horário da Agenda',
                                            text: res.message,
                                            icon: 'error',
                                            showConfirmButton: false
                                        });
                                    } else {
                                        window.toast({
                                            error: false,
                                            text: res.message
                                        })
                                        $('.js-update-event-manager-dialog-close').trigger('click');
                                        $("#calendar").block(window._loader.loading);
                                        self.bindAgendaData(true);

                                        Swal.fire({
                                            title: 'Horário da Agenda excluído',
                                            text: res.message,
                                            icon: 'success',
                                            showConfirmButton: false
                                        });
                                    }
                                },
                                errorCallback: function (err) {
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)
                                    //$(".modal-update-event-manager").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                                    console.error('ERROR', 'crud_agenda_admin.js/doctor/agenda/delete', '.js-manager-update-schedule-event', err);
                                }
                            })
                        }
                    });
                    break;
                }

                case 'DesmarcarAtendimento': {
                    //console.log('Clicando para Desmarcar Atendimento', data)

                    Swal.fire({
                        title: 'Desmarcar Atendimento',
                        text: "Você tem certeza que deseja desmarcar o atendimento? Essa ação não poderá ser desfeita.",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancelar',
                        confirmButtonText: 'Sim, desmarcar atendimento!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $(".modal-update-event-manager").block();
                            $(selfBtn).prop('disabled', true)
                            apiCall({
                                method: 'POST',
                                endpoint: 'api/v1/doctor/agenda/unmark_as_attended',
                                data,
                                successCallback: function (res) {
                                    console.log('crud_agenda_admin.js/doctor/agenda/unmark_as_attended', '.js-manager-update-schedule-event', res);
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)

                                    if (res.error) {
                                        window.toast({
                                            error: true,
                                            text: res.message
                                        })

                                        Swal.fire({
                                            title: 'Erro ao desmarcar atendimento',
                                            text: res.message,
                                            icon: 'error',
                                            showConfirmButton: false
                                        });
                                    } else {
                                        window.toast({
                                            error: false,
                                            text: res.message
                                        })
                                        $('.js-update-event-manager-dialog-close').trigger('click');
                                        $("#calendar").block(window._loader.loading);
                                        self.bindAgendaData(true);

                                        Swal.fire({
                                            title: 'Atendimento desmarcado',
                                            text: res.message,
                                            icon: 'success',
                                            showConfirmButton: false
                                        });
                                    }
                                },
                                errorCallback: function (err) {
                                    $(".modal-update-event-manager").unblock();
                                    $(selfBtn).prop('disabled', false)
                                    //$(".modal-update-event-manager").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                                    console.error('ERROR', 'crud_agenda_admin.js/doctor/agenda/unmark_as_attended', '.js-manager-update-schedule-event', err);
                                }
                            })
                        }
                    });
                    break;
                }
            }
        });

        // Detecta usuário clicando para "Atualizar agendamento"
        $(document).on('submit', '.js-business-scheduler-update', function (e) {
            e.preventDefault();
            let data = $(this).serializeArray(),
                scheduleSelectedAgendaId = $('#agenda_edit_start_hour option:selected').data('agenda-id');

            data.push({
                name: 'agenda_edit_schedule_agenda_id',
                value: scheduleSelectedAgendaId
            });
            data.push({
                name: 'agenda_edit_customer_whatsapp_int',
                value: self.customerEditWhatsappInput.getNumber()
            });
            data.push({
                name: 'agenda_edit_patient_type',
                value: self.patientType
            });
            if (self.agendaEditExistingCustomer) {
                data.push({
                    name: 'agenda_edit_existing_customer',
                    value: self.agendaEditExistingCustomer
                });
            }

            if (self.currentAccountId) {
                for (let i in data) {
                    let obj = data[i];
                    if (obj.name == 'agenda_edit_patient_contract_session_id_and_contract_id') {
                        data.splice(i, 1);
                        break;
                    }
                }
                data.push({
                    name: 'agenda_edit_patient_contract_session_id_and_contract_id',
                    value: self.currentAccountId + '|0'
                });
            }

            $(".modal-update-event-manager-dialog").block(window._loader.loading);

            let selfModal = this;
            $(selfModal).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/doctor/agenda/update',
                data,
                successCallback: function (res) {
                    console.log('crud_agenda_admin.js/doctor/agenda/update', '.js-business-scheduler-update', res);
                    $(".modal-update-event-manager-dialog").unblock();
                    $(selfModal).find('button[type="submit"]').prop('disabled', false);

                    Swal.fire({
                        title: 'Atualização de Agendamento',
                        text: res.message,
                        icon: res.error ? 'error' : 'success',
                        showConfirmButton: false
                    });

                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        $('.js-update-event-manager-dialog-close').trigger('click');
                        $("#calendar").block(window._loader.loading);
                        self.bindAgendaData(true);
                    }
                },
                errorCallback: function (err) {
                    $(selfModal).find('button[type="submit"]').prop('disabled', false);
                    $(".modal-update-event-manager-dialog").unblock();
                    //$(".modal-update-event-manager-dialog").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                    console.error('ERROR', 'crud_agenda_admin.js/doctor/agenda/update', '.js-business-scheduler-update', err);
                }
            })
        });

        $(document).on('click', '.js-current-account-add-transaction', function () {
            self.selectedPatient = JSON.parse($(this).data('patient-info'));

            //console.log('self.seletecPatient', self.selectedPatient, self.selectedPatient.ID);
            $('#modal-current-account-add-transaction').addClass('child-modal');
            $(document).find('.child-modal').on('hidden.bs.modal', function () {
                //console.log('hiding child modal');
                $('body').addClass('modal-open');
            });

            $('#modal-current-account-add-transaction').modal('show');
            $('.js-current-account-add-transaction-form').trigger('reset');
            $("#edit_current_account_transaction_hunter").val(userHasRole('HUNTER') ? window._sessionData.userId : 'Clinica');
            $(".js-current-account-add-transaction-dialog-title-id").html(`${self.selectedPatient.ID}`);

            $('#edit_current_account_transaction_date').val(self.updateModalDataObj.obj.DATA_INICIO_FORMATED);
            $('#edit_current_account_doctor').val(self.updateModalDataObj.obj.DOUTORES_ID);
            if ($('#agenda_edit_service').val() != '') {
                $('#edit_current_account_service').val($('#agenda_edit_service').val());
                $('#edit_current_account_service').trigger('change');
                $('#edit_current_account_service').attr('readonly', true);
            } else {
                $('#edit_current_account_service').val('');
                $('#edit_current_account_service').attr('readonly', false);
            }
            $('#edit_current_account_transaction_patient_type').val(self.updateModalDataObj.obj.TIPO_PACIENTE_ID);

            // set readonly inputs
            $('#edit_current_account_transaction_date').attr('readonly', true);
            $('#edit_current_account_doctor').attr('readonly', true);
            $('#edit_current_account_transaction_patient_type').attr('readonly', true);
            $('.js-current-account-add-transaction-form').find('button[type="submit"]').html('Adicionar Transação e Agendar');
            window.reloadMasks();
        });

        // Detecta envio do formulário de inserção de conta corrente
        $(document).on('submit', '.js-current-account-add-transaction-form', function (e) {
            e.preventDefault();

            let serializeData = $(this).serializeArray();

            $(".modal-current-account-add-transaction-dialog").block(window._loader.loading);

            serializeData.push({
                name: 'edit_current_account_transaction_patient_old_data',
                value: self.selectedPatient
            })
            serializeData.push({
                name: 'edit_current_account_transaction_agenda_id',
                value: self.updateModalDataObj.obj.ID
            })

            serializeData.push({
                name: 'edit_current_account_transaction_service_name',
                value: $('#edit_current_account_service option:selected').text()
            })

            serializeData.push({
                name: 'edit_current_account_transaction_service_id',
                value: $('#edit_current_account_service').val()
            })

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/current_account_add_transaction',
                data: serializeData,
                successCallback: function (res) {
                    $(".modal-current-account-add-transaction-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    Swal.fire({
                        title: 'Agendamento e Transação de Conta Corrente',
                        text: res.message,
                        icon: res.error ? 'error' : 'success',
                        showConfirmButton: false
                    });

                    if (!res.error) {
                        $('.js-current-account-add-transaction-form').trigger('reset');
                        $("#edit_current_account_transaction_service_amount").val(1);
                        $('#modal-current-account-add-transaction').modal('hide');

                        //self.currentAccountId = res.data.ID;
                        //$('.js-business-scheduler-update').trigger('submit');

                        $('#modal-update-event-manager').modal('hide');

                        self.bindAgendaData(true);
                    }
                },
                errorCallback: function (err) {
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                    $(".modal-current-account-add-transaction-dialog").unblock();
                }
            });
        });

        // Deteca fechamento da tela de edição de agendamento
        $("#modal-update-event-manager").on("hidden.bs.modal", function () {
            // put your default event here
            if (self.isEditing) {
                self.isEditing = false;
                self.agendaEditExistingCustomer = false;
            }

            $('.js-business-scheduler-update').trigger('reset');

            $('#agenda_edit_search_customer').val('').trigger('change')
            $('#agenda_edit_service').val('');

            $('.js-agenda-edit-manager-currenct-account-transaction-container').addClass('d-none');
            $(".js-agenda-edit-manager-select-contract-container").html(``);
            $('.js-agenda-edit-post-patient').addClass('d-none');

            $('#agenda_edit_customer_name').val('');
            $('#agenda_edit_customer_whatsapp').val('');
            $('#agenda_edit_customer_profession').val('');
            $('#agenda_edit_origin').val('');

            $('#agenda_edit_customer_name').attr('readonly', false);
            $('#agenda_edit_customer_whatsapp').attr('readonly', false);
            $('#agenda_edit_customer_profession').attr('readonly', false);
            $('#agenda_edit_origin').attr('readonly', false);

            if (!$('.js-manager-update-schedule-event-accordion-title').hasClass('collapsed')) {
                $('.js-manager-update-schedule-event-accordion-title').trigger('click');
            }
        });

        $(document).on('click', '.js-start-facial-recognition', async function (e) {
            e.stopPropagation();
            self.enableLoader('#modal-reconhecimento-paciente');
            currentPatientIdForFacialRecognition = $(this).data('patient-id');
            //console.log('onClick', 'currentPatientIdForFacialRecognition', currentPatientIdForFacialRecognition, this);
            //return;

            const isToday = moment(self.filter.AGENDA_START_DATE).isSame(moment(), 'day');
            if (!isToday) {
                return window.toast({
                    error: true,
                    text: "Não é possível realizar a captura facial em uma data diferente de hoje (" + moment().tz('America/Sao_Paulo').format('DD/MM/YYYY') + ")."
                })
            }

            $('#modal-reconhecimento-paciente').modal('show');
            await fetch('https://facial-recognition.clinicasajustar.com.br/api/updateBranchData', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    branchId: self.filter.AGENDA_BUSINESS_BRANCH,
                    patientId: currentPatientIdForFacialRecognition,
                    patients: currentBranchPatients,
                    schedules: currentSchedules
                })
            });
            self.startRecognitionFn();
            self.disableLoader('#modal-reconhecimento-paciente');
        });

        $('#modal-reconhecimento-paciente').on('hidden.bs.modal', function () {
            self.stopVideoStream();
        });

        $(document).on('click', '.js-open-schedules-presence-confirmation', function () {
            let patientId = $(this).data('patient-id');
            let findSchedules = currentSchedules.filter((obj) => obj.CLIENTES_ID == patientId);
            //console.log('findSchedules', findSchedules);
            currentPresentSetPatientId = patientId;

            const video = document.getElementById('video');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Set canvas size to match video resolution
            canvas.width = video.videoWidth || 640;
            canvas.height = video.videoHeight || 480;

            document.getElementById('saveDescriptor').disabled = false;

            // Draw the full video frame onto the canvas
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            // Convert canvas to base64 JPEG
            const base64Image = canvas.toDataURL('image/jpeg', 0.9);

            let html = `<li>
                <img src="${base64Image}" width=640 height=480 />
            </li>`;
            $('.js-confirm-presence-btn').attr('data-base64img', base64Image);
            $('.js-confirm-presence-btn').prop('data-base64img', base64Image);
            $('.js-confirm-presence-btn').data('base64img', base64Image);
            for (let i = 0; i < findSchedules.length; i++) {
                let schedule = findSchedules[i];
                if (schedule.CATEGORIA == 'Agendado' || schedule.CATEGORIA == 'Confirmado') {
                    html += `
                        <li class="list-group-item d-flex align-items-center border-0 border-bottom py-3">
                            <div class="form-check w-100">
                                <input class="form-check-input" type="checkbox" value="${schedule.ID}" id="${schedule.ID}">
                                <label class="form-check-label d-block" for="${schedule.ID}">
                                    <div class="d-flex align-items-center gap-2">
                                        <small class="text-muted">#${schedule.ID}</small>
                                        <strong class="text-primary">${schedule.DOUTOR_NOME}</strong>
                                        <span class="text-dark">
                                            ${moment(schedule.DATA_INICIO).tz('America/Sao_Paulo').format('DD/MM/YYYY')} 
                                            ${moment(schedule.HORA_INICIO).tz('America/Sao_Paulo').format('HH:mm')}-${moment(schedule.HORA_FINAL).tz('America/Sao_Paulo').format('HH:mm')}
                                        </span>
                                        <span class="text-success">${schedule.SERVICOS}</span>
                                    </div>
                                </label>
                            </div>
                        </li>
                    `;
                }
            }
            $('.js-confirm-presence-list').html(html);
        });

        $(document).on('click', '.js-confirm-presence-btn', async () => {
            let data = $('.js-confirm-presence-list').find('input[type="checkbox"]:checked');
            let base64Image = $('.js-confirm-presence-btn').data('base64img');
            let mustGivePresenceAgendaIds = [];
            for (let i = 0; i < data.length; ++i) {
                let el = data[i];
                mustGivePresenceAgendaIds.push($(el).val())
            };

            if (mustGivePresenceAgendaIds.length === 0)
                return window.toast({
                    error: true,
                    text: "Você deve selecionar pelo menos um agendamento do paciente para dar presença."
                })

            try {
                self.enableLoader('#modal-confirma-presenca');
                try {
                    const rawResponse = await fetch(window._baseDir + 'api/v1/facial-recognition/set-as-present', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            patientId: parseInt(currentPresentSetPatientId),
                            agendaIds: mustGivePresenceAgendaIds,
                            proofImage: base64Image
                        })
                    });
                    const content = await rawResponse.json();
                    if (content.error) {
                        window.toast({ error: true, text: content.message })
                    } else {
                        lastMatchTimestamp = 0;
                        $('#modal-confirma-presenca').modal('hide');
                        $('#modal-reconhecimento-paciente').modal('hide');
                        $(".js-agenda-reload-btn").trigger('click');
                        //$('#startRecognition').trigger('click');
                        self.stopVideoStream();
                        window.toast({ error: false, text: content.message });
                    }
                } catch (ex) {
                    console.error('[main.js]', 'set-as-present', 'TheQuiro server failed to fullfil a response.', ex?.message)
                    return { error: true, error: ex?.message };
                }
                self.disableLoader('#modal-confirma-presenca');
                //console.log('result', result);

            } catch (ex) {
                window.toast({ error: true, text: 'Ocorreu um erro ao dar presença' });
            }
        });

        class FaceRegistration {
            constructor() {
                this.video = document.getElementById('inputVideo');
                this.capturesGrid = document.getElementById('capturesGrid');
                this.qualityIndicator = document.getElementById('qualityIndicator');
                this.progressFill = document.getElementById('progressFill');

                this.captures = [];
                this.isCapturing = false;
                this.requiredCaptures = 5;
                this.detectionInterval = null;
                this.videoBkp = null;

                this.xhrRequests = [];

                // Override face-api's internal canvas creation method
                /*if (faceapi.env) {
                    const env = faceapi.env.getEnv();
                    env.createCanvasElement = () => {
                        const canvas = document.createElement('canvas');
                        return canvas;
                    };
                    
                    // Also override the image creation method if needed
                    env.createImageElement = () => {
                        const img = document.createElement('img');
                        return img;
                    };
                }*/

                this.setupEventListeners();
            }

            async initialize() {
                try {
                    // Create environment override if it wasn't available in constructor
                    /*if (!faceapi.env) {
                        await new Promise(resolve => setTimeout(resolve, 100));
                        const env = faceapi.env.getEnv();
                        env.createCanvasElement = () => {
                            const canvas = document.createElement('canvas');
                            return canvas;
                        };
                        
                        env.createImageElement = () => {
                            const img = document.createElement('img');
                            return img;
                        };
                    }*/
                    //await this.startVideo();
                } catch (error) {
                    console.error('Initialization error:', error);
                }
            }

            setupEventListeners() {
                let self2 = this;

                document.getElementById('saveDescriptor').addEventListener('click', async () => {
                    await this.saveDescriptor();
                });

                $(document).on('click', '.js-open-capture-patient', async function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    $('#modal-captura-paciente').modal('show');

                    //const button = event.target.closest('.js-open-capture-patient');
                    const patientId = $(this).data('patient-id');
                    document.getElementById('patientId').value = patientId;
                    console.log('set patientId', patientId);
                    self.stopVideoStream();
                    await self2.startVideo();
                    //this.detectBlinking();
                    self2.startCapturing();
                });

                const modal = document.getElementById('modal-captura-paciente');
                modal.addEventListener('hidden.bs.modal', async function () {
                    self2.xhrRequests.forEach(controller => controller.abort());
                    self2.xhrRequests = [];

                    const video = document.getElementById('inputVideo');
                    const stream = video.srcObject;

                    // Stop all tracks in the stream
                    if (stream) {
                        const tracks = stream.getTracks();
                        tracks.forEach(track => track.stop());
                        video.srcObject = null;
                    }

                    if (isRecognizin) {
                        const videoMain = document.getElementById('video');
                        const streamMain = await navigator.mediaDevices.getUserMedia({ video: true });
                        videoMain.srcObject = streamMain;
                        startFaceRecognition();
                    }

                    if (self2.isCapturing) {
                        self2.isCapturing = false;
                    }
                });

                document.getElementById('saveCapture').addEventListener('click', async () => {
                    const patientId = document.getElementById('patientId').value;
                    const tempCanvas = document.createElement('canvas');
                    tempCanvas.width = self2.video.videoWidth;
                    tempCanvas.height = self2.video.videoHeight;
                    tempCanvas.getContext('2d').drawImage(self2.video, 0, 0);

                    const imageData = tempCanvas.toDataURL('image/jpeg', 0.7);

                    let controller = new AbortController();
                    self2.videoBkp = imageData;
                    self2.xhrRequests.push(controller);
                    self.enableLoader('#modal-captura-paciente');
                    const response = await fetch('https://facial-recognition.clinicasajustar.com.br/api/captureFce', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            imageData,
                            patientId: patientId
                        }),
                        signal: controller.signal
                    });

                    self2.xhrRequests = self2.xhrRequests.filter(req => req !== controller);
                    self.disableLoader('#modal-captura-paciente');

                    const result = await response.json();

                    if (result?.descriptor) {
                        await this.captureFrame(result.descriptor[0]);
                    }
                    //const detection = await this.detectFace();
                    //if (detection) {
                    //await this.captureFrame(detection);
                    //}
                })

                document.addEventListener("click", function (event) {
                    //console.log(event.target.className);
                    const target = event.target;
                    if (target.className == 'delete-btn') {
                        const index = target.dataset.index;
                        const elementToRemove = document.querySelector(`.canvas-container[data-index="${index}"]`);
                        if (elementToRemove) {
                            elementToRemove.remove();

                            // Remove from the array
                            self2.capturesGrid = self2.capturesGrid.filter((_, i) => i !== index);

                            // Update indexes to keep them consistent
                            self2.capturesGrid.forEach((el, i) => {
                                el.dataset.index = i;
                                el.querySelector(".delete-btn").dataset.index = i;
                            });
                        }
                    }
                });

                // Handle video events
                this.video.addEventListener('loadedmetadata', () => {
                    //console.log('Video metadata loaded');
                });

                this.video.addEventListener('play', () => {
                    //console.log('Video started playing');
                    this.startDetection();
                });
            }

            async startVideo() {
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({
                        video: {
                            width: { ideal: 1280 },
                            height: { ideal: 720 }
                        }
                    });
                    this.video.srcObject = stream;
                    await this.video.play();
                } catch (error) {
                    console.error('Error starting video:', error);
                }
            }

            startDetection() {
                if (this.detectionInterval) {
                    clearInterval(this.detectionInterval);
                }

                /*this.detectionInterval = setInterval(async () => {
                    if (!this.isCapturing || this.video.paused || this.video.ended) return;
        
                    try {
                        /*const detection = await this.detectFace();
                        if (detection) {
                            this.updateQualityIndicator(detection);
                            //if (this.isGoodQuality(detection)) {
                            //    await this.captureFrame(detection);
                            //}
                        }*
                    } catch (error) {
                        console.error('Detection error:', error);
                    }
                }, 1000);*/
            }

            async detectFace() {
                return await faceapi
                    .detectSingleFace(this.video)
                    .withFaceLandmarks()
                    .withFaceDescriptor();
            }

            /*isGoodQuality(detection) {
                const faceSize = detection.detection.box.area;
                const minSize = this.video.videoWidth * this.video.videoHeight * 0.1;
                const landmarks = detection.landmarks;
                const angle = this.calculateFaceAngle(landmarks);
        
                return faceSize > minSize && Math.abs(angle) < 15;
            }
        
            calculateFaceAngle(landmarks) {
                const leftEye = landmarks.getLeftEye()[0];
                const rightEye = landmarks.getRightEye()[0];
                return Math.atan2(rightEye.y - leftEye.y, rightEye.x - leftEye.x) * 180 / Math.PI;
            }
        
            updateQualityIndicator(detection) {
                const quality = this.isGoodQuality(detection);
                this.qualityIndicator.className = `quality-indicator quality-${quality ? 'good' : 'bad'}`;
                this.qualityIndicator.textContent = quality ? 
                    'Boa qualidade - por favor aguarde' : 
                    'Centralize seu rosto e olhe para frente';
            }*/

            base64ToImageSource(base64, callback) {
                const img = new Image();
                img.onload = () => callback(img);
                img.src = base64; // Set base64 as source
            }

            async captureFrame(detection) {
                let self2 = this;
                //console.log('detection', detection);
                if (this.captures.length >= this.requiredCaptures) return;

                const lastCapture = this.captures[this.captures.length - 1];
                if (lastCapture && Date.now() - lastCapture.timestamp < 500) return;

                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const size = 96;
                canvas.width = size;
                canvas.height = size;
                document.getElementById('saveDescriptor').disabled = false;

                // Convert the raw detection box to a face-api rect
                const rect = new faceapi.Rect(
                    detection.detection._box._x,
                    detection.detection._box._y,
                    detection.detection._box._width,
                    detection.detection._box._height
                );

                const cImg = this.base64ToImageSource(this.videoBkp, (img) => {
                    const box = rect;
                    ctx.drawImage(
                        img,
                        box.x, box.y, box.width, box.height,
                        0, 0, size, size
                    );

                    // Convert canvas to base64 JPEG
                    const base64Image = canvas.toDataURL('image/jpeg', 0.9);

                    const index = self2.capturesGrid.children.length; // Get the current index

                    self2.captures.push({
                        descriptor: detection.descriptor,
                        timestamp: Date.now(),
                        image: base64Image
                    });

                    const container = document.createElement("div");
                    container.classList.add("canvas-container");
                    container.dataset.index = index; // Store the index in the container

                    // Create delete button
                    const deleteBtn = document.createElement("span");
                    deleteBtn.classList.add("delete-btn");
                    deleteBtn.textContent = "X";
                    deleteBtn.dataset.index = index; // Store the index in the button

                    // Append canvas and delete button to container
                    container.appendChild(canvas);
                    container.appendChild(deleteBtn);

                    // Append container to capturesGrid
                    self2.capturesGrid.appendChild(container);

                    if (self2.captures.length === self2.requiredCaptures) {
                        document.getElementById('saveDescriptor').disabled = false;
                    }
                })


            }

            calculateAverageDescriptor() {
                const sum = new Float32Array(128);
                this.captures.forEach(capture => {
                    for (let i = 0; i < 128; i++) {
                        sum[i] += capture.descriptor[i];
                    }
                });
                return sum.map(val => val / this.captures.length);
            }

            async saveDescriptor() {
                const patientId = document.getElementById('patientId').value;

                if (!patientId) {
                    window.toast({ error: true, text: 'Please enter Patient ID and Branch ID' });
                    return;
                }

                if (this.captures.length === 0) {
                    window.toast({ error: true, text: "Por favor, tire as fotos do paciente antes de salvar" });
                    return;
                }

                if (this.captures.length < 2) {
                    window.toast({ error: true, text: "Por favor, tire pelo menos 2 fotos do paciente." });
                    return;
                }

                const averageDescriptor = this.calculateAverageDescriptor();

                try {
                    self.enableLoader('#modal-captura-paciente');
                    const rawResponse = await fetch(window._baseDir + 'api/v1/facial-recognition/save-face-descriptor', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            patientId: parseInt(patientId),
                            descriptor: Array.from(averageDescriptor),
                            captures: this.captures
                        })
                    });
                    const content = await rawResponse.json();
                    self.disableLoader('#modal-captura-paciente');
                    const result = { error: content.error, response: content.response };
                    //console.log('result', result);
                    if (!result.error) {
                        window.toast({ error: false, text: 'Traços faciais salvos com sucesso!' });
                        this.resetCapture();
                    } else {
                        window.toast({ error: true, text: `Erro ao salvar traços faciais: ${result.error}` });
                    }
                } catch (error) {
                    window.toast({ error: true, text: 'Erro ao salvar traços faciais: ' + error.message });
                }
            }

            startCapturing() {
                if (!this.isCapturing) {
                    this.isCapturing = true;
                    this.captures = [];
                    this.capturesGrid.innerHTML = '';
                    document.getElementById('saveDescriptor').disabled = false;
                    document.getElementById('saveCapture').disabled = false;
                } else {
                    this.resetCapture();
                }
            }

            async resetCapture() {
                this.isCapturing = false;
                this.captures = [];
                this.capturesGrid.innerHTML = '';
                clearInterval(this.detectionInterval);
                $('#modal-captura-paciente').modal('hide');
                //document.getElementById('saveDescriptor').disabled = true;
                //document.getElementById('saveCapture').disabled = true;
                document.getElementById('patientId').value = '';
                //console.log('reset patientId');
                //await loadBranchPatients(currentSelectedBranchId);
                $(".js-agenda-reload-btn").trigger('click');
            }
        }

        const faceRegistration = new FaceRegistration();
        faceRegistration.initialize().catch(console.error);
    }

    checkIfHasAnyContractWithTwoServicesAvailable(obj) {
        for (let key in obj) {
            // Skip key '0'
            if (key != 0) {
                let innerObj = obj[key];
                let trueCount = 0;

                // Count how many properties have true values
                for (let innerKey in innerObj) {
                    if (innerObj[innerKey] === true) {
                        trueCount++;
                    }
                }

                // If we found exactly 2 true values
                if (trueCount === 2) {
                    console.log(`Key ${key} has two properties with true values:`, innerObj);
                    return true;
                }
            }
        }
        return false;
    }

    async initializeFaceAPI() {
        /*this.enableLoader();
        await Promise.all([
            faceapi.nets.ssdMobilenetv1.loadFromUri('models'),
            faceapi.nets.faceRecognitionNet.loadFromUri('models'),
            faceapi.nets.faceLandmark68Net.loadFromUri('models'),
            faceapi.nets.tinyFaceDetector.loadFromUri("models")
        ]);*/
    }

    startRecognitionFn() {
        if (this.filter.AGENDA_BUSINESS_BRANCH == null || currentBranchPatients.length == 0 || currentSchedules.length == 0)
            return window.toast({
                error: true,
                text: "Por favor selecione uma filial que possua uma agenda."
            })

        if (!isRecognizin) {
            isRecognizin = true;
            //$('#startRecognition').html('<i class="fas fa-stop"></i> Para Reconhecimento');
            this.initFaceRecognition();
            $('.camera-container').removeClass('d-none');
        } else {
            this.stopVideoStream();
        }
    }

    // Init Face Recognition after button click
    async initFaceRecognition() {
        const matchResult = document.getElementById('matchResult');
        matchResult.innerHTML = `
            <div class="match-info">
                Reconhecendo...
            </div>
        `;

        // Start webcam
        const video = document.getElementById('video');
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        video.srcObject = stream;

        this.startFaceRecognition();
    }

    // Start face recognition
    async startFaceRecognition() {
        const video = document.getElementById('video');
        const canvas = document.getElementById('overlay');
        const displaySize = { width: video.width || 640, height: video.height || 480 };

        faceapi.matchDimensions(canvas, displaySize);

        let self = this;

        mainRecognitionTimer = setInterval(async () => {
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = video.videoWidth;
            tempCanvas.height = video.videoHeight;
            tempCanvas.getContext('2d').drawImage(video, 0, 0);

            const imageData = tempCanvas.toDataURL('image/jpeg', 0.7);

            if (recognitionTicks > recognitionMaxTicks) {
                recognitionTicks = 0;
                $('#modal-reconhecimento-paciente').modal('hide');
                self.stopVideoStream();
                window.toast({
                    error: true,
                    text: `A câmera é pausada depois de ${recognitionMaxTicks} segundos de atividade.`
                });
                return;
            }

            try {
                let controller = new AbortController();
                activeRequests.push(controller);
                const response = await fetch('https://facial-recognition.clinicasajustar.com.br/api/recognizeFace', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        imageData,
                        patientId: currentPatientIdForFacialRecognition,
                        branchId: this.filter.AGENDA_BUSINESS_BRANCH
                    }),
                    signal: controller.signal
                });
                activeRequests = activeRequests.filter(req => req !== controller);

                const result = await response.json();
                if (result.matched) {
                    lastMatchTimestamp = Date.now();
                    const matchedPatient = currentBranchPatients.find(
                        p => p.ID.toString() === result.patientId
                    );
                    //console.log('matchedPatient', matchedPatient);

                    if (matchedPatient) {
                        self.displayMatch(matchedPatient);

                        // Clear previous drawings
                        const ctx = canvas.getContext('2d');
                        ctx.clearRect(0, 0, canvas.width, canvas.height);

                        // Convert the raw detection box to a face-api rect
                        const rect = new faceapi.Rect(
                            result.detection.box._x,
                            result.detection.box._y,
                            result.detection.box._width,
                            result.detection.box._height
                        );

                        // Draw detection box with patient name
                        const drawBox = new faceapi.draw.DrawBox(rect, {
                            label: matchedPatient.NOME_COMPLETO
                        });

                        drawBox.draw(canvas);
                    }
                } else {
                    const timeSinceLastMatch = Date.now() - lastMatchTimestamp;
                    if (timeSinceLastMatch > MATCH_HOLD_DURATION) {
                        // Clear previous drawings
                        const ctx = canvas.getContext('2d');
                        ctx.clearRect(0, 0, canvas.width, canvas.height);

                        const matchResult = document.getElementById('matchResult');
                        matchResult.innerHTML = `
                            <div class="match-info">
                                Reconhecendo...
                            </div>
                        `;
                    }
                }
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error('Face recognition error:', error);
                }
            }
            recognitionTicks++;
        }, 1000);
    }

    // Display match result
    displayMatch(patient) {
        //if (patient.ID != lastMatchedPatient) {
        const matchResult = document.getElementById('matchResult');
        matchResult.innerHTML = `
                <div class="match-info">
                    <h4>${patient.NOME_COMPLETO}</h4>
                    <p>ID: ${patient.ID}</p>
                    <button class="btn btn-sm btn-success js-open-schedules-presence-confirmation" data-bs-toggle="modal" data-bs-target="#modal-confirma-presenca" data-patient-id="${patient.ID}"><i class="fas fa-check me-1"></i>Confirmar Presença</button>
                </div>
            `;
        lastMatchedPatient = patient.ID;
        //}
    }

    stopVideoStream() {
        //document.getElementById('startRecognition').innerHTML = '<i class="fas fa-play"></i> Iniciar Reconhecimento'
        isRecognizin = false;
        clearInterval(mainRecognitionTimer);

        const video = document.getElementById('video');
        const stream = video.srcObject;

        // Stop all tracks in the stream
        if (stream) {
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            video.srcObject = null;
        }

        const canvas = document.getElementById('overlay');
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);

        activeRequests.forEach(controller => controller.abort());
        activeRequests = [];

        $('.camera-container').addClass('d-none');
    }

    // Activates screen loader
    enableLoader(target = null) {
        $(target ? target : 'body').block(window._loader.loading);
    }

    // Deactivates screen loader
    disableLoader(target = null) {
        $(target ? target : 'body').unblock();
    }

}
